// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-06T21:26:26.322Z
// Property: Hackberry Ranch (ID: 6767906449167662)
// Collections: 32 amenities, 8 floorplans (live), 32 photos, 71 POIs, 3 reviews, 1 virtual tours, 6 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162466",
  "multihub_property_id": "6767906449167662",
  "property_external_id": "2409197",
  "property_zillow_url": "https://www.zillow.com/apartments/clute-tx/hackberry-ranch/5XjyxH/",
  "property_apartments_url": "https://www.apartments.com/z-042226-hackberry-ranch-clute-tx/vegbnkg/",
  "property_google_business_url": "https://www.google.com/maps/place/Hackberry+Ranch+Apartments/@29.0290355,-95.3952795,1000m/data=!3m2!1e3!4b1!4m6!3m5!1s0x86406bcb4acf01a3:0x5cc6d497b3e288ee!8m2!3d29.0290355!4d-95.3952795!16s%2Fg%2F11ybp2zp7k?entry=ttu&g_ep=EgoyMDI2MDgxNy4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57322526223",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "2409197\np2376691",
  "property_status": null,
  "property_slug": "hackberry-ranch",
  "property_name": "Hackberry Ranch",
  "property_website_url": "https://www.renthackberryranch.com",
  "property_domain": "https://www.renthackberryranch.com",
  "property_address": "201 Hackberry St",
  "property_full_address": "201 Hackberry St, Clute, TX 77531",
  "property_address_1": "201 Hackberry St",
  "property_address_2": null,
  "property_address_city": "Clute",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "77531",
  "property_address_country": "US",
  "property_address_county": "Brazoria County",
  "property_neighborhood_address": "South Brazoria County",
  "property_address_latitude": "29.0285743",
  "property_address_longitude": "-95.3938428",
  "property_email": "hackberrymanager@mox.living",
  "property_phone": "(979) 325-3320",
  "property_call_tracking_phone": "979-325-3320",
  "property_company_name": "Mox",
  "property_company_url": "https://www.mox.living/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Comfort, connection, and coastal convenience in Clute.</strong><br>Hackberry Ranch pairs one-, two-, and three-bedroom layouts with easy everyday finishes and community spaces for a well-rounded home base just off TX-332. Explore your options or schedule a tour today.</p>",
  "property_long_description": "Hackberry Ranch offers spacious one-, two-, and three-bedroom homes in Clute, TX, just minutes from Lake Jackson. With floor plans ranging from 475 to 1,069 square feet, these welcoming apartments offer comfortable living for a variety of lifestyles. Working professionals and families alike will feel right at home in this welcoming, pet-friendly community. Comfortable Homes with Practical FeaturesEvery apartment at Hackberry Ranch includes plank wood-like flooring, a dishwasher, and a private patio or balcony for outdoor relaxation. Ceiling fans and efficient appliances add everyday functionality and keep your home comfortable. Large closets give you plenty of storage, and on-site laundry facilities are available for easy, convenient use.Amenities Designed for Everyday EnjoymentThe resort-style swimming pool is a favorite gathering spot on warm Texas afternoons. The fully equipped fitness center is steps from your front door, making it easy to stay active on your schedule. Your pets are welcome here, and the bark park gives dogs a dedicated space to roam and play. A playground rounds out a community built for families and pet owners alike.A Connected Location in the Heart of BrazosportSituated along TX-332 near TX-288, Hackberry Ranch puts you minutes from everyday shopping at H-E-B and the Brazos Mall in Lake Jackson. Dow Chemical and BASF, two of the area's largest employers, are both a short drive away in Freeport. Residents also enjoy easy access to Brazosport College, while the Brazosport Center for the Arts and Sciences, located right in Clute, brings culture and entertainment close to home.Schedule your tour at Hackberry Ranch and see your new home today.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1a-a58d-758c-9aae-181c30348725.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
    "public_id": "019ffd1a-a58d-758c-9aae-181c30348725",
    "storage_key": "property/6767906449167662/019ffd1a-a58d-758c-9aae-181c30348725.webp",
    "width": 1500,
    "height": 1000
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "520",
  "property_year_built": "1980",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.61538461538461",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "0",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "We are proud partners with PetScreening.com! Pet rents range; please contact the office for details on rents and size/breed restrictions.",
  "property_pet_policy_description": "We understand that pets are part of the family. That's why your pets are welcome to join our community at Hackberry Ranch.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://renthackberryranch.securecafeapplicant.com/onlineleasing/content3/access/hackberry-ranch-520-354-788/login",
  "property_resident_portal_url": "https://renthackberryranch.securecafenet.com/residentservices/hackberry-ranch-520-354-788/userlogin",
  "property_apply_now_url": "https://renthackberryranch.securecafeapplicant.com/onlineleasing/content3/access/hackberry-ranch-520-354-788/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025d6-05d0-777f-82c0-6115d98bab0c.webp",
  "property_primary_logo_media": {
    "alt_text": "Hackberry Ranch Apartments logo",
    "public_id": "01a025d6-05d0-777f-82c0-6115d98bab0c",
    "storage_key": "property/6767906449167662/01a025d6-05d0-777f-82c0-6115d98bab0c.webp",
    "width": 1400,
    "height": 819
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-facf-722d-a05d-d6f0e5b415fb.webp",
  "property_secondary_logo_media": {
    "alt_text": "RH logo",
    "public_id": "019ffd19-facf-722d-a05d-d6f0e5b415fb",
    "storage_key": "property/6767906449167662/019ffd19-facf-722d-a05d-d6f0e5b415fb.webp",
    "width": 183,
    "height": 150
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025d6-a9f2-77be-b6c3-cf3d5ef3120c.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a025d6-a9f2-77be-b6c3-cf3d5ef3120c",
    "storage_key": "property/6767906449167662/01a025d6-a9f2-77be-b6c3-cf3d5ef3120c.webp",
    "width": 1280,
    "height": 748
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025d6-9ed0-70f8-b9f8-b4748629dd51.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a025d6-9ed0-70f8-b9f8-b4748629dd51",
    "storage_key": "property/6767906449167662/01a025d6-9ed0-70f8-b9f8-b4748629dd51.webp",
    "width": 1280,
    "height": 748
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0b110-11a0-73bb-ba59-e09d0fa98a78.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0105a-2d11-75c8-b1a7-2269011410e5.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0b10f-c4d1-77d8-b6d1-8c4ee1490c37.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0105a-2d11-75c8-b1a7-2269011410e5.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#173f51",
  "property_secondary_color": "#668fa0",
  "property_font_color": null,
  "property_color_4": "#c4c7c3",
  "property_color_3": "#191919",
  "property_color_5": "#ffffff",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "475 - 851",
  "property_sqft_min": "475",
  "property_sqft_max": "851",
  "property_price_range": "649 - 1000",
  "property_price_min": "649",
  "property_price_max": "1000",
  "property_available_units": 197,
  "property_facebook_url": "https://www.facebook.com/HackberryRanchApts",
  "property_instagram_url": "https://www.instagram.com/hackberryranchapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJowHPSstrQIYR7ojis5fUxlw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/hackberry-ranch-clute-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Hackberry Ranch",
  "property_home_romance_title": "Find Your Sanctuary: Embrace Life at Our Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, right at home.</strong> Hackberry Ranch brings together practical perks and relaxing spaces, from a fitness center and swimming pool to a courtyard and on-site dog park. On-site management, responsive maintenance, and laundry facilities help simplify the routine, while in-home features like efficient appliances, dishwashers, generous closets, ceiling fans, and private patios or balconies add comfort where it counts. See more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Hackberry Ranch offers one-, two-, and three-bedroom apartments in Clute, TX, with easy-to-compare layouts, pricing, and availability. Select homes add wood-style plank flooring, granite countertops, custom cabinetry, efficient appliances, and a private patio or balcony—details that make each space feel polished, practical, and ready for everyday living.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Hackberry Ranch.</strong> Preview bright interiors, updated kitchens with sleek black appliances, soft bedroom finishes, and patio or balcony views that bring in extra breathing room.</p><p>Then take a look around the Clute community, from the sparkling pool and sundeck seating to grilling areas, a fitness center with free weights, laundry options, walk-up access, and pet-friendly outdoor space. Like what you see? View the full gallery for more.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Clute connections, Gulf Coast energy.</strong> From Hackberry Ranch, local favorites like El Toro and Center Court Pizza &amp; Brew are close, with Clute Municipal Park nearby for trails, disc golf, events, and open-air downtime. Weekends can lead to the BASF Planetarium, Mammoth Lake, or beach days toward Surfside, Quintana, and Bryan Beach—all with convenient TX-332/TX-288 access to keep the area within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews highlight service that stands out.</strong> At Hackberry Ranch, feedback often points to helpful, patient team members, friendly interactions, and quick attention when apartment needs come up. Reviews also mention a welcoming community feel, thoughtful resident events, and a team described as “friendly and good people.” See why one reviewer called it a “10 out of 10,” then explore more real feedback from Hackberry Ranch residents.</p>",
  "property_neighborhood_blurb": "<p><strong>Find your rhythm in South Brazoria County.</strong> From Hackberry Ranch, Clute feels easy to explore—local spots like El Toro and Center Court Pizza &amp; Brew are close by, while Clute Municipal Park brings trails, disc golf, events, and room to unwind in the open air. On weekends, trade the usual routine for the Brazosport Museum of Natural Science and BASF Planetarium, a dive at Mammoth Lake, or a Gulf Coast outing toward Surfside, Quintana, and Bryan Beach. Everyday connections are simple, too, with TX-332/TX-288 access and Gulf Coast Transit District service near the community. Use the map below to get a feel for the area, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Hackberry Ranch fits into your Clute routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make every day easier.</strong> At Hackberry Ranch, your routine can move from a workout in the fitness center to downtime by the pool, a breath of fresh air in the courtyard, or a quick trip to the dog park without leaving the community. Practical conveniences like on-site management, responsive maintenance, and laundry facilities help keep the focus on living well in Clute.</p><p>Inside, the details are just as useful: efficient appliances, a dishwasher and disposal, generous closet space, ceiling fans, and private patio or balcony space in each home. Select finishes such as plank wood-like flooring add a clean, modern feel. Browse the <a href=\"/gallery\">photo gallery</a> to see the spaces, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Hackberry Ranch home?</strong><br>Choose from one-, two-, and three-bedroom layouts with everyday comforts like efficient appliances, large closets, ceiling fans, and private patios or balconies. With convenient community features and a well-connected Clute location, applying online is a simple next step toward your new apartment.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong><br>Connect with the Hackberry Ranch leasing team to learn more about our one-, two-, and three-bedroom apartments, everyday conveniences, and easy Clute location just off TX-332. We’re here to help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Hackberry Ranch?</strong><br>Start here for quick answers about the community, leasing, apartment layouts, amenities, and everyday living in Clute. If you need anything else, the on-site leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the space that works the way you do.</strong> Hackberry Ranch gives you a clear range of Clute floor plans, from efficient one-bedroom layouts to larger two- and three-bedroom designs with room to spread out. Compare open living areas, bedroom count, bathroom options, pricing, and real-time availability all in one place, then narrow your search by the details that matter most to your day-to-day routine.</p><p>Inside select homes, wood-style plank flooring adds a polished look, while well-equipped kitchens with efficient appliances, dishwasher, disposal, custom cabinetry, and granite countertops keep everyday tasks simple. Large closets, ceiling fans, carpeting, and a private patio or balcony round out the comfort. Explore the layouts below, review more <a href=\"/amenities\">interior finishes</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See Hackberry Ranch from every angle.</strong> Browse the gallery for a closer look at bright living spaces, updated kitchens with sleek black appliances, soft bedroom finishes, and private patio or balcony views that add breathing room to your day.</p><p>Outside, the photos move through the places that give this Clute community its easygoing rhythm: a sparkling pool with sundeck seating, grilling areas ready for relaxed evenings, a fitness center with free weights, and open-air spots designed for everyday downtime. You can also spot practical details like laundry options, walk-up access, and pet-friendly outdoor space as you compare what matters most.</p><p>Like what you see? Explore more <a href=\"/amenities\">community features</a>, check out <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Hackberry Ranch on the map.</strong><br>See available one-, two-, and three-bedroom apartments, then zoom out to place Clute convenience in view—from quick TX-332 and TX-288 access to nearby shopping, dining, parks, local arts, major Freeport destinations, and Gulf Coast beach days.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, nap, and settle in.</strong> At Hackberry Ranch, cats and dogs can feel at home with pet-friendly apartments in Clute and outdoor spaces that make daily routines easier. Head to the on-site pet play area for a burst of energy, take a quiet lap through the courtyard, or enjoy fresh air from your own patio or balcony in select homes.</p><p>With practical conveniences like on-site management, maintenance support, laundry options, and complimentary parking, pet care can fit more smoothly into your day. You’ll also find local pet supply and veterinary options nearby when errands call. Review the policy details below, explore more <a href=\"/amenities\">pet-friendly amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the community with your pet’s routine in mind.</p>",
  "property_referafriend_blurb": "<p><strong>Share life at Hackberry Ranch.</strong><br>Know someone who’d love easy apartment living in Clute? Invite them to explore comfortable one-, two-, and three-bedroom layouts, everyday conveniences, and community spaces made for relaxing, recharging, and connecting—then use the referral form to send them our way.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Hackberry Ranch.</strong><br>Pay rent, submit maintenance requests, and manage your account with the everyday ease that defines life here—practical apartment features, on-site management and maintenance, and a connected Clute location just off TX-332.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate about Hackberry Ranch.</strong> As you browse the reviews, you’ll notice praise for the people who keep the community running—helpful, patient team members, friendly service, and quick attention when something needs to be handled in an apartment.</p><p>Residents also point to a welcoming community feel, from thoughtful resident gatherings to everyday interactions that make the experience stand out. One longtime reviewer called the team “friendly and good people” and gave Hackberry Ranch a “10 out of 10.” Explore the ratings below to see what real residents are saying about life at Hackberry Ranch.</p>",
  "property_created_at": "1786657698101",
  "property_scheduletour_blurb": "<p><strong>See easy Clute living up close.</strong><br>Tour Hackberry Ranch and get a feel for one-, two-, and three-bedroom layouts with efficient appliances, large closets, private outdoor space, and select plank wood-like flooring—plus community extras like the pool, fitness center, and dog park. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we received your inquiry.</strong><br>Hackberry Ranch’s leasing team will follow up soon. In the meantime, picture easy Clute living with spacious <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a>, practical in-home finishes, and community extras like a pool, fitness center, courtyard, and dog park.</p>",
  "property_virtualtours_blurb": "<p><strong>Preview your next routine before you arrive.</strong> The Hackberry Ranch virtual tour gives you a closer look at the community fitness center, so you can explore the workout space from wherever you are. Move through the room at your own pace, check out the equipment setup, and picture how an on-site fitness option could fit into everyday living in Clute.</p><p>Use the tour as a starting point, then keep exploring more <a href=\"/amenities\">community amenities</a> or compare available <a href=\"/floor-plans\">floor plan layouts</a> when you’re ready to narrow your search. Like what you see online? <a href=\"/schedule-a-tour\">Schedule a tour</a> to experience Hackberry Ranch in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Hackberry Ranch",
  "property_seo_title_home": "Apartments in Clute, TX | Hackberry Ranch",
  "property_seo_description_home": "Discover apartments in Clute, TX at Hackberry Ranch. Explore spacious floor plans, community amenities, and a convenient Brazoria County location.",
  "property_seo_title_floorplans": "1, 2 & 3 Bedroom Apartments in Clute, TX | Hackberry Ranch",
  "property_seo_description_floorplans": "Explore 1, 2, and 3 bedroom apartments in Clute, TX at Hackberry Ranch. View available floor plans, apartment features, pricing, and availability.",
  "property_seo_title_amenities": "Apartments with Amenities in Clute, TX | Hackberry Ranch",
  "property_seo_description_amenities": "Explore Hackberry Ranch amenities in Clute, TX, including a dog park, playground, fitness center, business center, and convenient apartment features.",
  "property_seo_title_gallery": "Clute, TX Apartment Photos | Hackberry Ranch",
  "property_seo_description_gallery": "Browse photos of Hackberry Ranch apartments in Clute, TX. View apartment interiors, community spaces, amenities, and more in our gallery.",
  "property_seo_title_virtualtours": "Virtual Apartment Tours in Clute, TX | Hackberry Ranch",
  "property_seo_description_virtualtours": "Take a virtual tour of Hackberry Ranch in Clute, TX. Explore apartment interiors and community spaces online, then find the floor plan for you.",
  "property_seo_title_interactivemap": "Interactive Map | Hackberry Ranch Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Hackberry Ranch, Clute, TX! Choose from 1-3 bedroom apartments with great amenities and a community map.",
  "property_seo_title_neighborhood": "Apartments Near Lake Jackson, TX | Hackberry Ranch",
  "property_seo_description_neighborhood": "Explore apartments near Lake Jackson, TX at Hackberry Ranch in Clute, with access to Brazosport College, Freeport, shopping, dining, and more.",
  "property_seo_title_contact": "Contact Hackberry Ranch Apartments in Clute, TX",
  "property_seo_description_contact": "Contact Hackberry Ranch in Clute, TX to ask about floor plans, availability, amenities, or touring our apartment community.",
  "property_seo_title_faqs": "FAQs | Apartments in Clute, TX",
  "property_seo_description_faqs": "Uncover the answers you seek about Hackberry Ranch in Clute, TX. Dive into our FAQs and learn about our vibrant community and fantastic amenities!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Clute, TX",
  "property_seo_description_reviews": "Discover life at Hackberry Ranch, Clute, TX! Read resident reviews and explore our one-to-three bedroom apartments with vibrant amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Clute, TX",
  "property_seo_description_applynow": "Discover comfort and style at Hackberry Ranch, Clute, TX! Spacious floor plans, modern amenities—lease your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Hackberry Ranch",
  "property_seo_description_residentaccess": "Log in to Hackberry Ranch’s resident portal for easy rent payments, fast maintenance requests, and exclusive community updates from home!",
  "property_seo_title_referafriend": "Refer A Friend | Hackberry Ranch",
  "property_seo_description_referafriend": "Refer a friend to Hackberry Ranch in Clute, TX, and share the joy of great neighbors! Embrace a vibrant community and enjoy a welcoming lifestyle together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Hackberry Ranch",
  "property_seo_description_scheduletour": "Experience the charm of Hackberry Ranch in Clute, TX! Schedule your tour today and uncover the perfect blend of comfort and community. Your new home awaits!",
  "property_seo_title_privacy": "Privacy Policy | Hackberry Ranch",
  "property_seo_description_privacy": "At Hackberry Ranch in Clute, TX, your privacy matters. Learn how we protect your information while you enjoy your community. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Hackberry Ranch",
  "property_seo_description_accessibility": "At Hackberry Ranch in Clute, TX, we prioritize digital inclusion. Discover our commitment to accessibility and embrace a community that welcomes everyone!",
  "property_seo_title_sitemap": "Sitemap | Hackberry Ranch",
  "property_seo_description_sitemap": "Navigate your way through Hackberry Ranch in Clute, TX! Check out our sitemap for an easy glimpse into your future home and community.",
  "property_seo_title_thankyou": "Thank You | Hackberry Ranch",
  "property_seo_description_thankyou": "Thank you for reaching out to Hackberry Ranch in Clute, TX! Our team will connect with you soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet-Friendly Apartments in Clute, TX | Hackberry Ranch",
  "property_seo_description_pets": "Discover pet-friendly apartments in Clute, TX at Hackberry Ranch. Review our pet policy, fees, guidelines, and community pet amenities.",
  "property_updated_at": "1791321173935",
  "amenities": [
    {
      "id": "ec_3873a9df4d49f0fc5df55234",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128669186",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4cb4e4ed91665b1042c2effc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189140",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_837cdbf1fc3f7aa4d5a499be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189139",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_484424990b2ed4b816d43bc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127682907",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c8723310b405578cba62f8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127203362",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e8e4668a39f1a22659537a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127203365",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21ffd09ceae0f2e6aac9dd00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127203358",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9aace4282885cec45c8ade1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127203359",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18fd85027bae892300ba3636",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127203343",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7670984b0b737400c2f41d6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127203344",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8794741931bbdb1a96dfb12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127203346",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e48aed6f272a0c2a71b2cd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127203357",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d73383bc33d7fd40ac034d79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189151",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90315a124c0ae10355bf4356",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189152",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf7984fc7011db2750320b5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189148",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ec8fb3ec60c002766b7621c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189142",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5515cb057d4ef6abce7a22a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127249984",
      "title": "Efficient Appliances (select homes)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3eb425b0ac6de441c63d098",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127249971",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1be7ca1b123431bf1b7b798b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127249970",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5abd26b6a7b318993eed8c8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127249966",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05afa338c83a41febce26e66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127249965",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4046c4ecc1e67fa428a3c9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127249964",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95ee30fd44acc62c44c78aa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127249963",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_035c6e982ba5fce16c05ceab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189143",
      "title": "Electronic Thermostat (select homes)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bca385b131817139b053bdb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189144",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b338bd4d2cc6898a0ccc67a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "127249980",
      "title": "Plank Wood-like Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c239e33dc33892ace52dece",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128669199",
      "title": "Bath Tub",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a094915e840b486a97198230",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189158",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17597e6e4a1b094863ee6957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189162",
      "title": "Washer/dryer hookups (select homes)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2496b4009e90a3b1cc2d72a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189165",
      "title": "Online rent payment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6fd2cf90c52e86bdbaa0e9c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189170",
      "title": "Barbecue",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_441f7ad2863508f950b44641",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "yardi",
      "external_id": "128189171",
      "title": "24-hour maintenance",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_298b82ebfe2e5f2d1bb16f59",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-6eb7-7249-a4c0-230f291b604f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a025e2-6eb7-7249-a4c0-230f291b604f",
        "storage_key": "property/6767906449167662/01a025e2-6eb7-7249-a4c0-230f291b604f.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing and soaking up the sun. Lounge chairs are available for your comfort.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-005.jpg"
    },
    {
      "id": "ec_d1896307408d528156c7d2cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-7969-750c-8f18-461235d56f8e.webp",
      "image_media": {
        "alt_text": "Spacious living room with a TV displaying the Hackberry Ranch Apartments logo, a large sectional sofa, armchair, and coffee table.",
        "public_id": "01a025e2-7969-750c-8f18-461235d56f8e",
        "storage_key": "property/6767906449167662/01a025e2-7969-750c-8f18-461235d56f8e.webp",
        "width": 640,
        "height": 640
      },
      "title": "Apartment",
      "description": "Relax in the comfortable living room of your new apartment. This space features a large sofa, accent chair, and a TV, perfect for entertaining or unwinding.",
      "link": "false",
      "alt_text": "Spacious living room with a TV displaying the Hackberry Ranch Apartments logo, a large sectional sofa, armchair, and coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-8.png"
    },
    {
      "id": "ec_65e0d0df380241a25a4f7e41",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-b916-7128-8757-1a1396f98916.webp",
      "image_media": {
        "alt_text": "Blue building with manicured flower beds and trees.",
        "public_id": "01a025e2-b916-7128-8757-1a1396f98916",
        "storage_key": "property/6767906449167662/01a025e2-b916-7128-8757-1a1396f98916.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Welcome to our community's clubhouse, a beautifully landscaped building with vibrant flowers and lush trees, offering a serene and inviting atmosphere.",
      "link": "false",
      "alt_text": "Blue building with manicured flower beds and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-002.jpg"
    },
    {
      "id": "ec_1b7cf26957047dc86fea70a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-964c-77b8-83c3-d89bc92ea346.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including a tunnel, ramp, and weave poles.",
        "public_id": "01a025e2-964c-77b8-83c3-d89bc92ea346",
        "storage_key": "property/6767906449167662/01a025e2-964c-77b8-83c3-d89bc92ea346.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Our on-site dog park provides a safe and fun space for your furry friends to play and socialize with agility equipment.",
      "link": "false",
      "alt_text": "Dog park with agility equipment including a tunnel, ramp, and weave poles.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-015.jpg"
    },
    {
      "id": "ec_34ce065c04b2dfad72343f9e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-7a31-765a-b2b8-ae0c4b5e8137.webp",
      "image_media": {
        "alt_text": "Living room with TV, sofa, coffee table, and view into bedroom.",
        "public_id": "01a025e2-7a31-765a-b2b8-ae0c4b5e8137",
        "storage_key": "property/6767906449167662/01a025e2-7a31-765a-b2b8-ae0c4b5e8137.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a flat-screen TV, comfortable seating, and a coffee table, with a view into a well-appointed bedroom.",
      "link": "false",
      "alt_text": "Living room with TV, sofa, coffee table, and view into bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-009.jpg"
    },
    {
      "id": "ec_06cba5e11deedd4d4e63d881",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-a2c1-73e8-ab1b-a8f783059f67.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a gazebo at a multifamily property.",
        "public_id": "01a025e2-a2c1-73e8-ab1b-a8f783059f67",
        "storage_key": "property/6767906449167662/01a025e2-a2c1-73e8-ab1b-a8f783059f67.webp",
        "width": 2117,
        "height": 1588
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush greenery and comfortable lounge chairs. Perfect for relaxing on a sunny day.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and a gazebo at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-MLS-4.png"
    },
    {
      "id": "ec_fa089176464d76f2b8f6450a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-7a24-71ef-92c5-18cec4a24d0e.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and dining area.",
        "public_id": "01a025e2-7a24-71ef-92c5-18cec4a24d0e",
        "storage_key": "property/6767906449167662/01a025e2-7a24-71ef-92c5-18cec4a24d0e.webp",
        "width": 640,
        "height": 640
      },
      "title": "Apartment",
      "description": "Stylish living and dining area in an apartment featuring a comfortable sectional sofa, a round coffee table, and a dining set.",
      "link": "false",
      "alt_text": "Modern living room with a sectional sofa, coffee table, and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-7.png"
    },
    {
      "id": "ec_661b720aa51a00ee2fee30af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-7a86-707d-b8e4-16473e2ba152.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets and granite countertops.",
        "public_id": "01a025e2-7a86-707d-b8e4-16473e2ba152",
        "storage_key": "property/6767906449167662/01a025e2-7a86-707d-b8e4-16473e2ba152.webp",
        "width": 640,
        "height": 640
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring white cabinetry, granite countertops, and a dishwasher, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-13.png"
    },
    {
      "id": "ec_f9644c6a37a6343ae80f2db4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-9852-7141-948e-263be95de2eb.webp",
      "image_media": {
        "alt_text": "Playground with slides, swings, and climbing structures under a shaded canopy.",
        "public_id": "01a025e2-9852-7141-948e-263be95de2eb",
        "storage_key": "property/6767906449167662/01a025e2-9852-7141-948e-263be95de2eb.webp",
        "width": 640,
        "height": 640
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a safe and shaded play area for children.",
      "link": "false",
      "alt_text": "Playground with slides, swings, and climbing structures under a shaded canopy.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-20.png"
    },
    {
      "id": "ec_fbbddf2c42e8971f42bc0e4c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-7a26-72ef-8bb0-5b27e4aafc0b.webp",
      "image_media": {
        "alt_text": "Close-up of a modern kitchen featuring a black electric stove and white cabinets.",
        "public_id": "01a025e2-7a26-72ef-8bb0-5b27e4aafc0b",
        "storage_key": "property/6767906449167662/01a025e2-7a26-72ef-8bb0-5b27e4aafc0b.webp",
        "width": 640,
        "height": 640
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen space with a sleek black electric stove, ample cabinet storage, and granite countertops, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Close-up of a modern kitchen featuring a black electric stove and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-12.png"
    },
    {
      "id": "ec_f07044677d49b2a0a66ea346",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-81bf-72d5-a405-bff7a19ca17c.webp",
      "image_media": {
        "alt_text": "A compact kitchen with white cabinets, granite countertops, a black refrigerator, and a black stove.",
        "public_id": "01a025e2-81bf-72d5-a405-bff7a19ca17c",
        "storage_key": "property/6767906449167662/01a025e2-81bf-72d5-a405-bff7a19ca17c.webp",
        "width": 640,
        "height": 640
      },
      "title": "Apartment",
      "description": "Explore this well-appointed kitchen, featuring ample cabinet space, elegant granite countertops, and modern black appliances, perfect for home chefs.",
      "link": "false",
      "alt_text": "A compact kitchen with white cabinets, granite countertops, a black refrigerator, and a black stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-11.png"
    },
    {
      "id": "ec_3a688fa7c46d7e1dfadf3205",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-a7d2-70ff-8b85-31a8367099ac.webp",
      "image_media": {
        "alt_text": "Lobby area with couches, chairs, and a reception desk.",
        "public_id": "01a025e2-a7d2-70ff-8b85-31a8367099ac",
        "storage_key": "property/6767906449167662/01a025e2-a7d2-70ff-8b85-31a8367099ac.webp",
        "width": 640,
        "height": 640
      },
      "title": "Community",
      "description": "The welcoming lobby area features comfortable seating, a reception desk, and stylish decor, creating an inviting atmosphere for residents and guests.",
      "link": "false",
      "alt_text": "Lobby area with couches, chairs, and a reception desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-5.png"
    },
    {
      "id": "ec_9b21c9ae9c1cc31d0b5ecdc5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-82cd-70b9-ab9b-5408bd2bbad0.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances, white cabinets, and speckled countertops.",
        "public_id": "01a025e2-82cd-70b9-ab9b-5408bd2bbad0",
        "storage_key": "property/6767906449167662/01a025e2-82cd-70b9-ab9b-5408bd2bbad0.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Modern and functional kitchen featuring black appliances including a refrigerator and oven, complemented by white cabinetry and durable speckled countertops. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Kitchen with black appliances, white cabinets, and speckled countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-011.jpg"
    },
    {
      "id": "ec_db90aa36f6b2bf150c8d5142",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-8f7a-7389-9cbc-1c269f1a3b14.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a tufted headboard, plush bedding, and a large decorative clock.",
        "public_id": "01a025e2-8f7a-7389-9cbc-1c269f1a3b14",
        "storage_key": "property/6767906449167662/01a025e2-8f7a-7389-9cbc-1c269f1a3b14.webp",
        "width": 640,
        "height": 640
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-size bed and elegant decor. Perfect for relaxation.",
      "link": "false",
      "alt_text": "Luxurious bedroom with a tufted headboard, plush bedding, and a large decorative clock.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-14.png"
    },
    {
      "id": "ec_6585a92b45def334000c24b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-8330-753f-8b7d-ba76c6e64e20.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel sink, black refrigerator, and white cabinets.",
        "public_id": "01a025e2-8330-753f-8b7d-ba76c6e64e20",
        "storage_key": "property/6767906449167662/01a025e2-8330-753f-8b7d-ba76c6e64e20.webp",
        "width": 1521,
        "height": 1014
      },
      "title": "Apartment",
      "description": "A bright and clean kitchen featuring a double sink, ample counter space, and modern appliances, perfect for home cooking.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel sink, black refrigerator, and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/the life at forestview-poi-002.jpg"
    },
    {
      "id": "ec_97a5e2e4cd0ee92725bb8c32",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-85d4-7116-b919-fc574e1cd254.webp",
      "image_media": {
        "alt_text": "Round dining table with place settings and a decorative cowboy boot centerpiece.",
        "public_id": "01a025e2-85d4-7116-b919-fc574e1cd254",
        "storage_key": "property/6767906449167662/01a025e2-85d4-7116-b919-fc574e1cd254.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "The dining area features a round table set for four, perfect for intimate meals or entertaining guests.",
      "link": "false",
      "alt_text": "Round dining table with place settings and a decorative cowboy boot centerpiece.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-010.jpg"
    },
    {
      "id": "ec_609acdce002f9655ec1d3033",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-97f0-758c-b5a6-047f46cf92ba.webp",
      "image_media": {
        "alt_text": "Community dog park with agility equipment and a bench.",
        "public_id": "01a025e2-97f0-758c-b5a6-047f46cf92ba",
        "storage_key": "property/6767906449167662/01a025e2-97f0-758c-b5a6-047f46cf92ba.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility obstacles for your furry friends and a relaxing bench for owners.",
      "link": "false",
      "alt_text": "Community dog park with agility equipment and a bench.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-19.png"
    },
    {
      "id": "ec_39664b2d89eb6daec89d7a65",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-8700-703d-89d7-1a1947690b9a.webp",
      "image_media": {
        "alt_text": "Dining area with a round table set for four people, featuring a cowboy boot as a centerpiece.",
        "public_id": "01a025e2-8700-703d-89d7-1a1947690b9a",
        "storage_key": "property/6767906449167662/01a025e2-8700-703d-89d7-1a1947690b9a.webp",
        "width": 640,
        "height": 640
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this inviting dining area, perfect for meals and gatherings. Features a round dining table and stylish seating.",
      "link": "false",
      "alt_text": "Dining area with a round table set for four people, featuring a cowboy boot as a centerpiece.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-9.png"
    },
    {
      "id": "ec_62444c8b72d92f1fb11a11e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-8aed-74ff-bf63-6263d4eb2cd1.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, walk-in closet, and en-suite bathroom access.",
        "public_id": "01a025e2-8aed-74ff-bf63-6263d4eb2cd1",
        "storage_key": "property/6767906449167662/01a025e2-8aed-74ff-bf63-6263d4eb2cd1.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush king-size bed, a convenient walk-in closet, and direct access to the en-suite bathroom. Experience comfort and style in this beautifully appointed room.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, walk-in closet, and en-suite bathroom access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-012.jpg"
    },
    {
      "id": "ec_00ae7bacfb9b995b3a9d6e96",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-b58e-742d-a0c2-6c18c6fcd65b.webp",
      "image_media": {
        "alt_text": "Blackberry Ranch Apartments leasing office with a welcome sign, seating area, and reception desk.",
        "public_id": "01a025e2-b58e-742d-a0c2-6c18c6fcd65b",
        "storage_key": "property/6767906449167662/01a025e2-b58e-742d-a0c2-6c18c6fcd65b.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Welcome to the leasing office at Blackberry Ranch Apartments. Relax in our comfortable seating area or speak with our friendly staff at the reception desk.",
      "link": "false",
      "alt_text": "Blackberry Ranch Apartments leasing office with a welcome sign, seating area, and reception desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-004.jpg"
    },
    {
      "id": "ec_fc2dfeb064cccd4bf849d17d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-8d52-7289-98c9-8cabc57fced7.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, pillows, and a view into the bathroom.",
        "public_id": "01a025e2-8d52-7289-98c9-8cabc57fced7",
        "storage_key": "property/6767906449167662/01a025e2-8d52-7289-98c9-8cabc57fced7.webp",
        "width": 640,
        "height": 640
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed with plush pillows and a serene color palette. The adjoining bathroom is visible, offering convenience and style.",
      "link": "false",
      "alt_text": "Bedroom with a bed, pillows, and a view into the bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-15.png"
    },
    {
      "id": "ec_dfd9a14466368b9347323c05",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-acef-74ec-9f19-5ee023495a80.webp",
      "image_media": {
        "alt_text": "Lobby with plush seating and reception desk.",
        "public_id": "01a025e2-acef-74ec-9f19-5ee023495a80",
        "storage_key": "property/6767906449167662/01a025e2-acef-74ec-9f19-5ee023495a80.webp",
        "width": 640,
        "height": 640
      },
      "title": "Community",
      "description": "Spacious lobby area featuring comfortable seating and a welcoming reception desk, perfect for residents and guests.",
      "link": "false",
      "alt_text": "Lobby with plush seating and reception desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-3.png"
    },
    {
      "id": "ec_52229042f2d672812a66f761",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-9015-724b-9682-65ef90f7be69.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, bathtub, and vanity with sink.",
        "public_id": "01a025e2-9015-724b-9682-65ef90f7be69",
        "storage_key": "property/6767906449167662/01a025e2-9015-724b-9682-65ef90f7be69.webp",
        "width": 640,
        "height": 640
      },
      "title": "Apartment",
      "description": "A clean and well-lit bathroom featuring a toilet, bathtub, and a vanity with a sink. Includes decorative elements like a wooden shelf with towels and decorative mirrors.",
      "link": "false",
      "alt_text": "Bathroom with a toilet, bathtub, and vanity with sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-16.png"
    },
    {
      "id": "ec_f8c52f5265c5acf5828deec9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-925d-715f-ba10-0931e4d93eaa.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a grassy lawn in the foreground.",
        "public_id": "01a025e2-925d-715f-ba10-0931e4d93eaa",
        "storage_key": "property/6767906449167662/01a025e2-925d-715f-ba10-0931e4d93eaa.webp",
        "width": 640,
        "height": 640
      },
      "title": "Community",
      "description": "Charming exterior view of the apartment buildings, showcasing the lush green lawn and mature trees.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with a grassy lawn in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-18.png"
    },
    {
      "id": "ec_e12362db826bc77e88a91b65",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-a44e-71e8-8f82-05c6d2b3a7c4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs next to apartment buildings.",
        "public_id": "01a025e2-a44e-71e8-8f82-05c6d2b3a7c4",
        "storage_key": "property/6767906449167662/01a025e2-a44e-71e8-8f82-05c6d2b3a7c4.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and the beautiful apartment complex.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs next to apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-006.jpg"
    },
    {
      "id": "ec_1ae1f939d4b7f4b5508fa0d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-999a-736e-82ea-ef7da8ae5fbf.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures, covered by a large shade sail.",
        "public_id": "01a025e2-999a-736e-82ea-ef7da8ae5fbf",
        "storage_key": "property/6767906449167662/01a025e2-999a-736e-82ea-ef7da8ae5fbf.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring safe and engaging play structures for children. It's the perfect place for families to connect and play.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structures, covered by a large shade sail.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-013.jpg"
    },
    {
      "id": "ec_48a1080d41f38d46c4bf5e1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-99df-77bc-bd8a-0c25b60f2c9b.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, free weights, and motivational wall art.",
        "public_id": "01a025e2-99df-77bc-bd8a-0c25b60f2c9b",
        "storage_key": "property/6767906449167662/01a025e2-99df-77bc-bd8a-0c25b60f2c9b.webp",
        "width": 640,
        "height": 640
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, weight machines, free weights, and inspiring artwork to motivate your workout.",
      "link": "false",
      "alt_text": "Gym with treadmills, weight machines, free weights, and motivational wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-17.png"
    },
    {
      "id": "ec_8cffa6993989c3a862c8edbf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-a57f-7548-b021-da96fa8862dd.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a025e2-a57f-7548-b021-da96fa8862dd",
        "storage_key": "property/6767906449167662/01a025e2-a57f-7548-b021-da96fa8862dd.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, the perfect place to relax and unwind after a long day.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-007.jpg"
    },
    {
      "id": "ec_f7cb8718f081a8657348455a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-b4ff-7735-ba2b-97b71cebd1a0.webp",
      "image_media": {
        "alt_text": "Comfortable seating area in the leasing office with desks and computers.",
        "public_id": "01a025e2-b4ff-7735-ba2b-97b71cebd1a0",
        "storage_key": "property/6767906449167662/01a025e2-b4ff-7735-ba2b-97b71cebd1a0.webp",
        "width": 640,
        "height": 640
      },
      "title": "Community",
      "description": "Relax and work in our spacious leasing office, featuring comfortable seating and a business center with computers and Wi-Fi.",
      "link": "false",
      "alt_text": "Comfortable seating area in the leasing office with desks and computers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-6.png"
    },
    {
      "id": "ec_66a008e7044e5479a6463aff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-b5df-761d-abf4-a3010e8b7c3c.webp",
      "image_media": {
        "alt_text": "Lobby area with comfortable seating, a large map of the property, and decorative elements.",
        "public_id": "01a025e2-b5df-761d-abf4-a3010e8b7c3c",
        "storage_key": "property/6767906449167662/01a025e2-b5df-761d-abf4-a3010e8b7c3c.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting lobby, featuring plush seating and a convenient property map.",
      "link": "false",
      "alt_text": "Lobby area with comfortable seating, a large map of the property, and decorative elements.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-003.jpg"
    },
    {
      "id": "ec_cb112972f7519d29a74bbc3d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-b732-7388-95d1-657788414543.webp",
      "image_media": {
        "alt_text": "Blue building with balloons in front of entrance, surrounded by flowers and greenery.",
        "public_id": "01a025e2-b732-7388-95d1-657788414543",
        "storage_key": "property/6767906449167662/01a025e2-b732-7388-95d1-657788414543.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Welcome to our community! The leasing office entrance is decorated with festive balloons and colorful flowers, creating a warm and inviting atmosphere.",
      "link": "false",
      "alt_text": "Blue building with balloons in front of entrance, surrounded by flowers and greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/Hackberry Ranch-POI-001.jpg"
    },
    {
      "id": "ec_d4b8da26c865af84c3f5b55d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/01a025e2-be31-7538-ab94-3d61f521659a.webp",
      "image_media": {
        "alt_text": "Hackberry Ranch Apartments monument sign with building exterior and trees in the background.",
        "public_id": "01a025e2-be31-7538-ab94-3d61f521659a",
        "storage_key": "property/6767906449167662/01a025e2-be31-7538-ab94-3d61f521659a.webp",
        "width": 640,
        "height": 640
      },
      "title": "Community",
      "description": "Welcome to Hackberry Ranch Apartments, featuring a prominent monument sign and charming apartment buildings surrounded by mature trees and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Hackberry Ranch Apartments monument sign with building exterior and trees in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/201-hackberry-st-clute-tx-77531-mls-2.png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_18c5b39a-beca-45d1-8364-c38eaa32c6e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Asiel's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "330 Dixie Dr G, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Casual lakeside restaurant offering American comfort fare & deck seating, plus a full bar.",
      "poi_long_description": "Casual lakeside restaurant offering American comfort fare & deck seating, plus a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-315e-720e-ac7f-e00021379e5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-315e-720e-ac7f-e00021379e5f",
        "storage_key": "property/6767906449167662/019ffd19-315e-720e-ac7f-e00021379e5f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://asielstexas.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=18233662678670420259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asiels-restaurant",
      "poi_latitude": "29.0294833",
      "poi_longitude": "-95.4208194",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-285-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw7o0oolBQIYRI6lypJn7Cv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d08efefb-bfeb-42ec-ab6c-e4719be88713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Brew N Bake",
      "poi_type": "Restaurants",
      "poi_address": "145 Oyster Creek Dr, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Casual bakery with outdoor seating serving coffee, homemade desserts, sandwiches, salads & wraps.",
      "poi_long_description": "Casual bakery with outdoor seating serving coffee, homemade desserts, sandwiches, salads & wraps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-bbfb-76bc-9602-a16d9c34c9bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-bbfb-76bc-9602-a16d9c34c9bc",
        "storage_key": "property/6767906449167662/019ffd1c-bbfb-76bc-9602-a16d9c34c9bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brewnbake.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=816446050989351938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brew-n-bake",
      "poi_latitude": "29.0454658",
      "poi_longitude": "-95.4525488",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 979-297-1433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3cd1-779f-a48b-caf688bcc3da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3cd1-779f-a48b-caf688bcc3da",
        "storage_key": "property/6767906449167662/019ffd1d-3cd1-779f-a48b-caf688bcc3da.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ1bNc5MNDQIYRAqR9j1uZVAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_10417cce-d3c6-4e98-a880-419524f000ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Wayside Pub",
      "poi_type": "Restaurants",
      "poi_address": "106 This Way, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Traditional English pub fare, a variety of brews & entertainment such as board games & TV sports.",
      "poi_long_description": "Traditional English pub fare, a variety of brews & entertainment such as board games & TV sports.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-bae5-77ef-a3a9-27b9c32f6b28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-bae5-77ef-a3a9-27b9c32f6b28",
        "storage_key": "property/6767906449167662/019ffd1c-bae5-77ef-a3a9-27b9c32f6b28.webp",
        "width": 960,
        "height": 716
      },
      "poi_business_url": "http://www.waysidepub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9519944149561028530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wayside-pub",
      "poi_latitude": "29.0412367",
      "poi_longitude": "-95.44968",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 979-480-0378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8bFz8RDQIYRsq8k5MOiHYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "british_restaurant"
    },
    {
      "id": "custom_32917b4e-7e4d-4bcf-b1c6-5667be7f1bc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Big Thai Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "117 N Parking Pl, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Casual restaurant serving Thai cuisine including drunken noodles, coconut cake, and red curry with beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-bbf5-71f6-8f27-f8fff3790ac6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-bbf5-71f6-8f27-f8fff3790ac6",
        "storage_key": "property/6767906449167662/019ffd1c-bbf5-71f6-8f27-f8fff3790ac6.webp",
        "width": 1280,
        "height": 946
      },
      "poi_business_url": "http://www.bigthaitexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4914908179871552174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-thai-restaurant",
      "poi_latitude": "29.0425995",
      "poi_longitude": "-95.4486631",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 979-529-9278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7wxdROxDQIYRrtLnBPNCNUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_d0a795b3-5b48-4be0-b38d-ed46d46e8c08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Wurst Haus",
      "poi_type": "Restaurants",
      "poi_address": "102 This Way, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Family-owned spot offering a wide selection of craft brews & rustic German cooking.",
      "poi_long_description": "Family-owned spot offering a wide selection of craft brews & rustic German cooking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-c751-769e-a473-a95bd98635aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-c751-769e-a473-a95bd98635aa",
        "storage_key": "property/6767906449167662/019ffd1c-c751-769e-a473-a95bd98635aa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://wursthaus.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=263835447850780454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wurst-haus",
      "poi_latitude": "29.0414282",
      "poi_longitude": "-95.449305",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 979-297-3003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN5Ly2cRDQIYRJkdNJPFUqQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "german_restaurant"
    },
    {
      "id": "custom_6c58ea15-0591-4edb-9b7f-0c8979d5945d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Grape Taste Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "145 Oyster Creek Dr #10, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Warm, friendly restaurant serving American steaks & seafood plus a wine list of over 1,400 bottles.",
      "poi_long_description": "Warm, friendly restaurant serving American steaks & seafood plus a wine list of over 1,400 bottles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-baea-7468-bbbf-6bc84dd4eff7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-baea-7468-bbbf-6bc84dd4eff7",
        "storage_key": "property/6767906449167662/019ffd1c-baea-7468-bbbf-6bc84dd4eff7.webp",
        "width": 619,
        "height": 619
      },
      "poi_business_url": "https://thegrapetaste.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9710546503340743758&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grape-taste-restaurant",
      "poi_latitude": "29.0454618",
      "poi_longitude": "-95.4520609",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 979-480-0424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1bNc5MNDQIYRTlyJmpjKwoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8a05f455-3486-4906-b130-e8f90ea36ce9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Lake Jackson Seafood",
      "poi_type": "Restaurants",
      "poi_address": "466 Plantation Dr, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Lively eatery supplying seafood dishes such as fish, gumbo & salmon in a casual environment.",
      "poi_long_description": "Lively eatery supplying seafood dishes such as fish, gumbo & salmon in a casual environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-bcad-75fd-a2df-67e0475e6248.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-bcad-75fd-a2df-67e0475e6248",
        "storage_key": "property/6767906449167662/019ffd1c-bcad-75fd-a2df-67e0475e6248.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lakejacksonseafood.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13826959741652106778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-jackson-seafood",
      "poi_latitude": "29.0206249",
      "poi_longitude": "-95.4209951",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-297-8883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq56bZY5BQIYRGv7MbKA6478",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_1d236cb2-c84d-4169-ba8e-a824da4ca2d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Tokyo",
      "poi_type": "Restaurants",
      "poi_address": "602 TX-332, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Japanese eats and cocktails offered in a casual setting with hibachi chefs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-c29b-70c8-b79e-3af08c8a3465.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-c29b-70c8-b79e-3af08c8a3465",
        "storage_key": "property/6767906449167662/019ffd1c-c29b-70c8-b79e-3af08c8a3465.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tokyosteakhousetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12910407461359097869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tokyo",
      "poi_latitude": "29.0203268",
      "poi_longitude": "-95.4357347",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 979-297-9988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCSLpg4JBQIYRDZjcDy_7KrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_f8394cc5-e8eb-496b-99e1-aa594ffcaa7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Yoshi",
      "poi_type": "Restaurants",
      "poi_address": "90 Oak Dr Ste J, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Creative & traditional sushi & Japanese fare in a casual space with happy hour specials & catering.",
      "poi_long_description": "Creative & traditional sushi & Japanese fare in a casual space with happy hour specials & catering.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-c096-75ac-a105-1e6f7e0c67fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-c096-75ac-a105-1e6f7e0c67fa",
        "storage_key": "property/6767906449167662/019ffd1c-c096-75ac-a105-1e6f7e0c67fa.webp",
        "width": 1125,
        "height": 963
      },
      "poi_business_url": "https://yoshi.kwickmenu.com/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=15302881573060383578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoshi",
      "poi_latitude": "29.0414469",
      "poi_longitude": "-95.4469549",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 979-297-8887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxvEWsVDQIYRWpMiarbBXtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_122b8085-a559-43b2-969d-2613f365ffd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Swamp Shack Lake Jackson",
      "poi_type": "Restaurants",
      "poi_address": "111 Abner Jackson Pkwy, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Specializes in down-home seafood & steaks, with lots of fried options (like pickles) & a full bar.",
      "poi_long_description": "Specializes in down-home seafood & steaks, with lots of fried options (like pickles) & a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-bb97-739d-814f-f4722a7aa6af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-bb97-739d-814f-f4722a7aa6af",
        "storage_key": "property/6767906449167662/019ffd1c-bb97-739d-814f-f4722a7aa6af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://swampshacklj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11792470178679034468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swamp-shack-lake-jackson",
      "poi_latitude": "29.0403999",
      "poi_longitude": "-95.4573003",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 979-299-7444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcljBuhDQIYRZBKN-CVFp6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_c67d6bea-9eb3-4df9-ba02-3387b9bc0a3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "El Toro Mexican Restaurant - Clute",
      "poi_type": "Restaurants",
      "poi_address": "120 Commerce St, Clute, TX 77531, USA",
      "poi_short_description": "Long-running local chain offering classic Tex-Mex dishes in a casual atmosphere.",
      "poi_long_description": "Long-running local chain offering classic Tex-Mex dishes in a casual atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-314d-70d9-812c-93153af21593.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-314d-70d9-812c-93153af21593",
        "storage_key": "property/6767906449167662/019ffd19-314d-70d9-812c-93153af21593.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.eltorotexmex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=631227269735109583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-toro-mexican-restaurant---clute",
      "poi_latitude": "29.0145736",
      "poi_longitude": "-95.4032392",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 979-265-5361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq4mi6uVBQIYRz9MZgduRwgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_b8b40c5b-132f-476b-b366-f04f7b9e878f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Red Top",
      "poi_type": "Restaurants",
      "poi_address": "402 W Edgewood Dr, Friendswood, TX 77546, USA",
      "poi_short_description": "Burgers, eggrolls, and other quick bites offered in a casual American restaurant with a drive through.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-cc4a-70f4-8296-c0ac13f0d914.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-cc4a-70f4-8296-c0ac13f0d914",
        "storage_key": "property/6767906449167662/019ffd1c-cc4a-70f4-8296-c0ac13f0d914.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15935190239701481931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-top",
      "poi_latitude": "29.5295241",
      "poi_longitude": "-95.2109178",
      "poi_miles_from_property": "40.5",
      "poi_walking_minutes": "14 hours 46 mins",
      "poi_biking_minutes": "3 hours 50 mins",
      "poi_driving_minutes": "52 mins",
      "poi_business_phone": "+1 281-482-3368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7y45oJaaQIYRy7mtQRgrJd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3de6b41b-b861-4abc-8ab9-3f49a85f14a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Sharkies Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "10 Surf Dr, Surfside Beach, TX 77541, USA",
      "poi_short_description": "No-frills, late-night beach bar & grill offering burgers, deck seating, live music & karaoke nights.",
      "poi_long_description": "No-frills, late-night beach bar & grill offering burgers, deck seating, live music & karaoke nights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-d482-775a-9b17-a1b5472007b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-d482-775a-9b17-a1b5472007b1",
        "storage_key": "property/6767906449167662/019ffd1c-d482-775a-9b17-a1b5472007b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sharkiessurfside.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640977567876790919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharkies-bar--grill",
      "poi_latitude": "28.9509567",
      "poi_longitude": "-95.2871191",
      "poi_miles_from_property": "15.8",
      "poi_walking_minutes": "5 hours 45 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 979-871-9067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYyAJq8lsQIYRhzqW42sPjaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_65c8869d-c45d-4c6b-9f69-5030c425706b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Seahorse Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "310 Ocean Dr, Surfside Beach, TX 77541, USA",
      "poi_short_description": "An oceanfront venue serving burgers & other American fare, with a seasonal beach bar downstairs.",
      "poi_long_description": "An oceanfront venue serving burgers & other American fare, with a seasonal beach bar downstairs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-cabe-7499-8a47-c0b10e7c6cf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-cabe-7499-8a47-c0b10e7c6cf3",
        "storage_key": "property/6767906449167662/019ffd1c-cabe-7499-8a47-c0b10e7c6cf3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://app.upserve.com/s/seahorse-bar-and-grill-freeport",
      "poi_directions_map_url": "https://maps.google.com/?cid=4968069569260767610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seahorse-bar--grill",
      "poi_latitude": "28.9532539",
      "poi_longitude": "-95.281722",
      "poi_miles_from_property": "16.2",
      "poi_walking_minutes": "5 hours 54 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 979-239-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8xuc89sQIYRekk3h_Mg8kQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_cf9522db-8fb2-4462-9c27-6cb516f7a3df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Red Snapper Inn",
      "poi_type": "Restaurants",
      "poi_address": "402 Bluewater Hwy, Freeport, TX 77541, USA",
      "poi_short_description": "Cozy, popular seafood house with nautical decor & a menu featuring Greek-influenced fare.",
      "poi_long_description": "Cozy, popular seafood house with nautical decor & a menu featuring Greek-influenced fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-d0a1-774e-b9da-5574739877b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-d0a1-774e-b9da-5574739877b5",
        "storage_key": "property/6767906449167662/019ffd1c-d0a1-774e-b9da-5574739877b5.webp",
        "width": 1280,
        "height": 632
      },
      "poi_business_url": "http://www.redsnapperinn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5292057317420198806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-snapper-inn",
      "poi_latitude": "28.95474149999999",
      "poi_longitude": "-95.2841236",
      "poi_miles_from_property": "16",
      "poi_walking_minutes": "5 hours 50 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 979-239-3226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-UFKKVBQIYRlmvWdxcqcUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_57119d94-1f90-466a-8e94-e5bed001644b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 Dixie Dr, Clute, TX 77531, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-23a5-7169-be87-2ed906a6aed7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-23a5-7169-be87-2ed906a6aed7",
        "storage_key": "property/6767906449167662/019ffd19-23a5-7169-be87-2ed906a6aed7.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/clute/oyster-creek/034/00149?cid=loc_03400149_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12792807965808270502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "29.038144",
      "poi_longitude": "-95.421147",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 979-529-4391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1dd-758f-b422-20d60a8fc094.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1dd-758f-b422-20d60a8fc094",
        "storage_key": "property/6767906449167662/019ffd19-b1dd-758f-b422-20d60a8fc094.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8VHApJBQIYRphzK0RAvibE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_167428c5-0d1d-4c17-875e-5bf150066b4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "51 Dixie Dr Walgreens, Clute, TX 77531, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-d4ec-70f8-8356-39ec3ded07da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-d4ec-70f8-8356-39ec3ded07da",
        "storage_key": "property/6767906449167662/019ffd1c-d4ec-70f8-8356-39ec3ded07da.webp",
        "width": 1280,
        "height": 933
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-51+dixie+dr-clute-tx-77531/id=4100",
      "poi_directions_map_url": "https://maps.google.com/?cid=16836068981086205666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.0183859",
      "poi_longitude": "-95.4196391",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-265-2517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxThsB45BQIYR4radd4m7pek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_501ee600-0c97-499f-b5a5-993f14e6e637",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "The UPS Store",
      "poi_type": "Major Employers & Offices",
      "poi_address": "810 Dixie Dr Ste J, Clute, TX 77531, USA",
      "poi_short_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_long_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-d040-763f-a8e1-746dc9ff5b13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-d040-763f-a8e1-746dc9ff5b13",
        "storage_key": "property/6767906449167662/019ffd1c-d040-763f-a8e1-746dc9ff5b13.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://locations.theupsstore.com/tx/clute/810-north-dixie-dr?utm_source=Yext&utm_medium=organic&utm_campaign=Listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12969628969609624206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ups-store",
      "poi_latitude": "29.03880999999999",
      "poi_longitude": "-95.41986",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-266-9045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1ueLI1DQIYRjnoy8tRg_bM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shipping_service"
    },
    {
      "id": "custom_36617e0a-44bd-438a-9c6d-19f060e5132f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "857 W Plantation Dr, Clute, TX 77531, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-cf13-73a0-a445-96ed20ccef35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-cf13-73a0-a445-96ed20ccef35",
        "storage_key": "property/6767906449167662/019ffd1c-cf13-73a0-a445-96ed20ccef35.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/tx/clute/6751",
      "poi_directions_map_url": "https://maps.google.com/?cid=17463826925106312306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "29.0171661",
      "poi_longitude": "-95.4167824",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-341-9845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1cb-7690-a28d-57140a3e3ccf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1cb-7690-a28d-57140a3e3ccf",
        "storage_key": "property/6767906449167662/019ffd19-b1cb-7690-a28d-57140a3e3ccf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH4J4kpJBQIYRcjTdoQ_6W_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_c7964696-7b42-4c2f-a514-88b8453ce888",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Top Fast",
      "poi_type": "Shopping & Retail",
      "poi_address": "612 W Plantation Dr, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7946207974424234090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "top-fast",
      "poi_latitude": "29.0162776",
      "poi_longitude": "-95.4126585",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-265-9155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3c81-7138-9381-443596d241b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3c81-7138-9381-443596d241b4",
        "storage_key": "property/6767906449167662/019ffd1d-3c81-7138-9381-443596d241b4.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJWwyCBe1BQIYRasjuSg2aRm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_9541ab81-f6a0-4eed-86de-94be2efd08c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Danish Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "620 Brazosport Blvd S, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2092387171135620208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "danish-food-mart",
      "poi_latitude": "29.0158466",
      "poi_longitude": "-95.3938722",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 979-265-2822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3c81-7138-9381-443596d241b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3c81-7138-9381-443596d241b4",
        "storage_key": "property/6767906449167662/019ffd1d-3c81-7138-9381-443596d241b4.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJD8oz2AlqQIYRcIQf1AunCR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_d83b761d-7041-4ccb-b551-298d2aa4d9e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Food City Diner",
      "poi_type": "Restaurants",
      "poi_address": "113 Brazosport Blvd N, Clute, TX 77531, USA",
      "poi_short_description": "Comfort food classic eats such as burgers, oxtails, fish and chips and pork chops.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-da6b-7479-90a5-c4f706632db1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-da6b-7479-90a5-c4f706632db1",
        "storage_key": "property/6767906449167662/019ffd1c-da6b-7479-90a5-c4f706632db1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16772978066947440816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-city-diner",
      "poi_latitude": "29.0268373",
      "poi_longitude": "-95.3950697",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 979-388-0111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9lXPv5BQIYRsADSUa-Wxeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_cffac43c-5060-4b32-9c61-fbccd3480084",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Clute Food Mart",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 TX-288 Business, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-e3db-758f-a256-c9619fd6976f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-e3db-758f-a256-c9619fd6976f",
        "storage_key": "property/6767906449167662/019ffd1c-e3db-758f-a256-c9619fd6976f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://citgo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15436823209426088546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clute-food-mart",
      "poi_latitude": "29.0247833",
      "poi_longitude": "-95.395352",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 979-316-3291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3c8b-778d-a44b-b7c39357d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3c8b-778d-a44b-b7c39357d86e",
        "storage_key": "property/6767906449167662/019ffd1d-3c8b-778d-a44b-b7c39357d86e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJkVL01_1BQIYRYvJY0uucOtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_2c2a0684-6f27-4f15-87d2-b1184f939d19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "General Teran Meat Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "303 Brazosport Blvd S, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-dad3-77d8-9e77-691101123cbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-dad3-77d8-9e77-691101123cbc",
        "storage_key": "property/6767906449167662/019ffd1c-dad3-77d8-9e77-691101123cbc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2026495288286504156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "general-teran-meat-market",
      "poi_latitude": "29.0230799",
      "poi_longitude": "-95.3949027",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 979-529-2965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1cb-7690-a28d-57140a3e3ccf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1cb-7690-a28d-57140a3e3ccf",
        "storage_key": "property/6767906449167662/019ffd19-b1cb-7690-a28d-57140a3e3ccf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR9x3mv1BQIYR3ORRVbqOHxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "butcher_shop"
    },
    {
      "id": "custom_11b930fe-93ba-4886-8d35-96d5fe5458f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Clute Pawn & Jewelry",
      "poi_type": "Shopping & Retail",
      "poi_address": "617 Brazosport Blvd N, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-dad8-7252-819b-52f94ad77df0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-dad8-7252-819b-52f94ad77df0",
        "storage_key": "property/6767906449167662/019ffd1c-dad8-7252-819b-52f94ad77df0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://clutevelascopawn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9351627941003581675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clute-pawn--jewelry",
      "poi_latitude": "29.0310822",
      "poi_longitude": "-95.3973289",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 979-265-9595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1cb-7690-a28d-57140a3e3ccf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1cb-7690-a28d-57140a3e3ccf",
        "storage_key": "property/6767906449167662/019ffd19-b1cb-7690-a28d-57140a3e3ccf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUdAn1AFCQIYR69gitxCox4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_f38e01e8-ded6-437a-a32f-6a0fab412238",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "T.W. Ogg Elementary School",
      "poi_type": "Education",
      "poi_address": "200 N Lazy Ln, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-db8f-73ea-a522-b9ad6945864e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-db8f-73ea-a522-b9ad6945864e",
        "storage_key": "property/6767906449167662/019ffd1c-db8f-73ea-a522-b9ad6945864e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.brazosportisd.net/schools/t__w__ogg_elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=8169918082946755397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tw-ogg-elementary-school",
      "poi_latitude": "29.0232009",
      "poi_longitude": "-95.4129667",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-730-7195",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2f3Zo_NBQIYRResU2jVhYXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5187e1ce-8ae2-4b56-a12a-ec935c2a58f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Clute Intermediate School",
      "poi_type": "Education",
      "poi_address": "421 E Main St, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-df30-730e-ae5a-9d0e258ffd6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-df30-730e-ae5a-9d0e258ffd6c",
        "storage_key": "property/6767906449167662/019ffd1c-df30-730e-ae5a-9d0e258ffd6c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.brazosportisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=729856877257019282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clute-intermediate-school",
      "poi_latitude": "29.0223318",
      "poi_longitude": "-95.4005489",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 979-730-7230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHcSAkftBQIYRks_Hgfb4IAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f29f7ac1-d3b7-4cea-a9e8-18d5c4eabcd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Madge Griffith Elementary School",
      "poi_type": "Education",
      "poi_address": "101 Lexington Ave, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-df88-7156-ae72-3ed738bebd75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-df88-7156-ae72-3ed738bebd75",
        "storage_key": "property/6767906449167662/019ffd1c-df88-7156-ae72-3ed738bebd75.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.brazosportisd.net/schools/madge_griffith_elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=6520252654748542897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madge-griffith-elementary-school",
      "poi_latitude": "29.0439581",
      "poi_longitude": "-95.4071767",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 979-730-7180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi_o04hBCQIYRsacVZD6XfFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b06fd639-2f0f-4f1e-a098-f9b5f09cbab6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Brazoswood High School",
      "poi_type": "Education",
      "poi_address": "302 Brazoswood Dr, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-e759-7341-bb5b-1ad89454604a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-e759-7341-bb5b-1ad89454604a",
        "storage_key": "property/6767906449167662/019ffd1c-e759-7341-bb5b-1ad89454604a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bwhs.brazosportisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17490916349717904827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brazoswood-high-school",
      "poi_latitude": "29.026378",
      "poi_longitude": "-95.415316",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-730-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsTcUGfRBQIYRu_0Bzb83vPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a9388487-0612-4db2-a083-4b38c60d5b9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Brazosport College",
      "poi_type": "Education",
      "poi_address": "500 College Blvd, Lake Jackson, TX 77566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-3089-74f9-b082-1ba77cb511d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-3089-74f9-b082-1ba77cb511d8",
        "storage_key": "property/6767906449167662/019ffd19-3089-74f9-b082-1ba77cb511d8.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.brazosport.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1881860771551565227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brazosport-college",
      "poi_latitude": "29.0483827",
      "poi_longitude": "-95.4091723",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-230-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ__Vi-hNCQIYRq9UStWa2HRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_38316380-300b-48b2-9421-edbeb704eaa1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Lighthouse Learning Center",
      "poi_type": "Education",
      "poi_address": "1035 Dixie Dr, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-ea0f-757c-a9b0-fe2ea90a5ecb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-ea0f-757c-a9b0-fe2ea90a5ecb",
        "storage_key": "property/6767906449167662/019ffd1c-ea0f-757c-a9b0-fe2ea90a5ecb.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.brazosportisd.net/schools/lighthouse_learning",
      "poi_directions_map_url": "https://maps.google.com/?cid=4005956023203346270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lighthouse-learning-center",
      "poi_latitude": "29.01060739999999",
      "poi_longitude": "-95.4177969",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-730-7340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAWVMIpRBQIYRXjffVMcDmDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_7688f30d-08a8-4e5b-ade9-b0092de618d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Little Tykes Child Center",
      "poi_type": "Education",
      "poi_address": "220 S Shanks St, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8475886944276702227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-tykes-child-center",
      "poi_latitude": "29.0195579",
      "poi_longitude": "-95.400746",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 979-265-2539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdcfFNvtBQIYRE-T7xURmoHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_a5fa5ad7-ed8a-4713-b8e2-1e767b3f4a51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Kids Konnection Learning Acdmy",
      "poi_type": "Education",
      "poi_address": "211 S Lazy Ln, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-ec04-7724-af2a-7b16c016cfa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-ec04-7724-af2a-7b16c016cfa7",
        "storage_key": "property/6767906449167662/019ffd1c-ec04-7724-af2a-7b16c016cfa7.webp",
        "width": 1280,
        "height": 1056
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=97730981948497527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-konnection-learning-acdmy",
      "poi_latitude": "29.0195234",
      "poi_longitude": "-95.4120941",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 979-265-3590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIYNgiPJBQIYRdx6Xbs81WwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_5968c2c5-28d5-46af-85e8-355060196179",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "A Brighter Day Learning Academy",
      "poi_type": "Education",
      "poi_address": "925 W Plantation Dr, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9652285876019073748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-brighter-day-learning-academy",
      "poi_latitude": "29.017731",
      "poi_longitude": "-95.4178858",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-388-9586",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtTmocDJBQIYR1BKjPt3O84U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_95ae5808-ed02-4c20-b5d2-17c13961d780",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Tender Years Enrichment Learning Center",
      "poi_type": "Education",
      "poi_address": "900 W Plantation Dr, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8371591127303363770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tender-years-enrichment-learning-center",
      "poi_latitude": "29.0179594",
      "poi_longitude": "-95.4163305",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-266-8650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF9Fk4QFCQIYRupy6k8bdLXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_2eb32ab8-b5f0-4b45-b181-9519deff86c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "The Center for the Arts & Sciences",
      "poi_type": "Entertainment",
      "poi_address": "400 College Blvd, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-ecb8-77f8-9dd5-3a5f7364bc2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-ecb8-77f8-9dd5-3a5f7364bc2f",
        "storage_key": "property/6767906449167662/019ffd1c-ecb8-77f8-9dd5-3a5f7364bc2f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://bcfas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9019745357948451079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-center-for-the-arts--sciences",
      "poi_latitude": "29.0461582",
      "poi_longitude": "-95.4065016",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 979-265-7661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5WvutBFCQIYRB_n-SJ2SLH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_f9856c40-60e2-4e99-8e83-ebc0a662cb41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Brazosport Museum of Natural Science",
      "poi_type": "Entertainment",
      "poi_address": "400 College Blvd, Clute, TX 77531, USA",
      "poi_short_description": "Relaxed, low-key museum (for kids and adults) featuring exhibits of dinosaurs, wildlife, and shells.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-4ca0-77ca-b2ea-2acc2e197e12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-4ca0-77ca-b2ea-2acc2e197e12",
        "storage_key": "property/6767906449167662/019ffd19-4ca0-77ca-b2ea-2acc2e197e12.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bcfas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12046668601551797089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brazosport-museum-of-natural-science",
      "poi_latitude": "29.0459733",
      "poi_longitude": "-95.4068383",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 979-265-7661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b228-73fb-8ace-2a81b1051ece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b228-73fb-8ace-2a81b1051ece",
        "storage_key": "property/6767906449167662/019ffd19-b228-73fb-8ace-2a81b1051ece.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5WvutBFCQIYRYbtYYkRdLqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_29e49221-7054-4616-a43d-a6fb9cad0f9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "AMC CLASSIC Brazos Mall 14",
      "poi_type": "Entertainment",
      "poi_address": "100 TX-332, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Standard movie theater featuring discount tickets for new releases as well as concession specials.",
      "poi_long_description": "Standard movie theater featuring discount tickets for new releases as well as concession specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-f10b-74a8-a697-eb391d1a2136.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-f10b-74a8-a697-eb391d1a2136",
        "storage_key": "property/6767906449167662/019ffd1c-f10b-74a8-a697-eb391d1a2136.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/houston/amc-classic-brazos-mall-14?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4801921232758682635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-classic-brazos-mall-14",
      "poi_latitude": "29.0510059",
      "poi_longitude": "-95.4587275",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 979-316-4193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3ccc-76fd-bb00-103b9d97b1b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3ccc-76fd-bb00-103b9d97b1b5",
        "storage_key": "property/6767906449167662/019ffd1d-3ccc-76fd-bb00-103b9d97b1b5.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbYyfqCLP4YRC7T8ZevZo0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_c86f8f1f-1f9d-465c-8343-b1a4b00169e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Sea Center Texas",
      "poi_type": "Entertainment",
      "poi_address": "302 Medical Dr, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Marine museum with touch tanks, an aquarium, a hatchery & outdoor wetlands with a boardwalk trail.",
      "poi_long_description": "Marine museum with touch tanks, an aquarium, a hatchery & outdoor wetlands with a boardwalk trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-34e3-73dc-81d2-864faf59172f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-34e3-73dc-81d2-864faf59172f",
        "storage_key": "property/6767906449167662/019ffd19-34e3-73dc-81d2-864faf59172f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tpwd.state.tx.us/spdest/visitorcenters/seacenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5300814108973983062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-center-texas",
      "poi_latitude": "29.01748",
      "poi_longitude": "-95.4459616",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 979-292-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1de-73b9-aa36-7b1ebb804265.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1de-73b9-aa36-7b1ebb804265",
        "storage_key": "property/6767906449167662/019ffd19-b1de-73b9-aa36-7b1ebb804265.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJJ3BssNhDQIYRVuXF4VhGkEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_4c6d9c78-3aa1-44ca-90ba-c2e031313cea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Hardin Creek",
      "poi_type": "Restaurants",
      "poi_address": "219 Parking Way St, Lake Jackson, TX 77566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-f4ec-7239-aa77-a714ec9bb993.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-f4ec-7239-aa77-a714ec9bb993",
        "storage_key": "property/6767906449167662/019ffd1c-f4ec-7239-aa77-a714ec9bb993.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hardincreeklj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8784364121247251534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hardin-creek",
      "poi_latitude": "29.0419347",
      "poi_longitude": "-95.4504875",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 979-292-8180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b22a-70cf-8bb3-ef7d807c3e35",
        "storage_key": "property/6767906449167662/019ffd19-b22a-70cf-8bb3-ef7d807c3e35.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2VjS7cJDQIYRTvygcKBU6Hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d4c0bc69-9ffe-4cd9-8b8d-51fe74e2a265",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Surfside Jetty County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "101 Parkview Rd, Surfside Beach, TX 77541, USA",
      "poi_short_description": "Day-use beach park offering fishing, birdwatching & shell collecting, plus a playground & restrooms.",
      "poi_long_description": "Day-use beach park offering fishing, birdwatching & shell collecting, plus a playground & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-fad1-751a-bf9a-b25128af663d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-fad1-751a-bf9a-b25128af663d",
        "storage_key": "property/6767906449167662/019ffd1c-fad1-751a-bf9a-b25128af663d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://brazoriacountytx.gov/departments/parks-department/surfside-jetty",
      "poi_directions_map_url": "https://maps.google.com/?cid=5329145280592518451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "surfside-jetty-county-park",
      "poi_latitude": "28.9380657",
      "poi_longitude": "-95.2955537",
      "poi_miles_from_property": "15",
      "poi_walking_minutes": "5 hours 27 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 979-864-1541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d1-750e-a56e-5789d23133ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d1-750e-a56e-5789d23133ab",
        "storage_key": "property/6767906449167662/019ffd19-b1d1-750e-a56e-5789d23133ab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHREgXUwTQIYRM50qzmXt9Ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6720d7dc-b753-4e13-8743-5971a3b68462",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Quintana Beach County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "330 5th St, Quintana, TX 77541, USA",
      "poi_short_description": "Tranquil beachfront park offering access to a pier for fishing, plus playgrounds and campsites.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-f1eb-77fe-9507-897d21540f76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-f1eb-77fe-9507-897d21540f76",
        "storage_key": "property/6767906449167662/019ffd1c-f1eb-77fe-9507-897d21540f76.webp",
        "width": 1280,
        "height": 748
      },
      "poi_business_url": "http://brazoriacountytx.gov/departments/parks-department/quintana-beach",
      "poi_directions_map_url": "https://maps.google.com/?cid=8170370118760486320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quintana-beach-county-park",
      "poi_latitude": "28.9346868",
      "poi_longitude": "-95.3039594",
      "poi_miles_from_property": "13.9",
      "poi_walking_minutes": "5 hours 5 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 979-233-1461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3ce7-74ee-b2a5-9b27bc858b38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3ce7-74ee-b2a5-9b27bc858b38",
        "storage_key": "property/6767906449167662/019ffd1d-3ce7-74ee-b2a5-9b27bc858b38.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJbxA6JVETQIYRsFUvpFX8YnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "rv_park"
    },
    {
      "id": "custom_001099bd-43a6-46e6-90b7-410e480254b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Freeport Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "311 E Park Ave, Freeport, TX 77541, USA",
      "poi_short_description": "Kids' museum featuring displays on Texas and local history.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-f1ce-74fb-8f52-4ba9b7a18c4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-f1ce-74fb-8f52-4ba9b7a18c4a",
        "storage_key": "property/6767906449167662/019ffd1c-f1ce-74fb-8f52-4ba9b7a18c4a.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.freeportmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8199860443617419241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freeport-historical-museum",
      "poi_latitude": "28.9488552",
      "poi_longitude": "-95.3461103",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 979-233-0066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b228-73fb-8ace-2a81b1051ece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b228-73fb-8ace-2a81b1051ece",
        "storage_key": "property/6767906449167662/019ffd19-b228-73fb-8ace-2a81b1051ece.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8Kz2C5rQIYR6d-X9aDBy3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0e101efb-c625-4261-93b2-6703f2bd07f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Levi Jordan Plantation State Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "10510 FM524, Brazoria, TX 77422, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-0057-76fb-886f-c5d9dcd3725b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-0057-76fb-886f-c5d9dcd3725b",
        "storage_key": "property/6767906449167662/019ffd1d-0057-76fb-886f-c5d9dcd3725b.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://thc.texas.gov/historic-sites/levi-jordan-plantation",
      "poi_directions_map_url": "https://maps.google.com/?cid=14976475755564028096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "levi-jordan-plantation-state-historic-site",
      "poi_latitude": "29.0027241",
      "poi_longitude": "-95.6462788",
      "poi_miles_from_property": "22.8",
      "poi_walking_minutes": "8 hours 19 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 979-798-2202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3ce8-70ea-800c-e6ac789c1d21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3ce8-70ea-800c-e6ac789c1d21",
        "storage_key": "property/6767906449167662/019ffd1d-3ce8-70ea-800c-e6ac789c1d21.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_dGcvo9LQIYRwNCk1Vkh188",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_ac32a26f-37a4-4794-9b3c-56d815048027",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Brazoria County Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "100 E Cedar St, Angleton, TX 77515, USA",
      "poi_short_description": "Area museum housing exhibits on the history of the county and the surrounding Gulf Coast, plus a research library.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-fec0-7705-8bde-b4156a342c14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-fec0-7705-8bde-b4156a342c14",
        "storage_key": "property/6767906449167662/019ffd1c-fec0-7705-8bde-b4156a342c14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brazoriacountytx.gov/departments/museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=18203466932211635654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brazoria-county-historical-museum",
      "poi_latitude": "29.1690517",
      "poi_longitude": "-95.4314234",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 979-864-1208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b228-73fb-8ace-2a81b1051ece.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b228-73fb-8ace-2a81b1051ece",
        "storage_key": "property/6767906449167662/019ffd19-b228-73fb-8ace-2a81b1051ece.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJTw7aqABdQIYRxlULj7q0n_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c93e1247-0dcc-420d-9849-4b8fcd815eef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "St. Luke's Health - Brazosport Hospital - Lake Jackson, TX",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Medical Dr, Lake Jackson, TX 77566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-7731-70ac-851f-1cbf05fa90e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-7731-70ac-851f-1cbf05fa90e9",
        "storage_key": "property/6767906449167662/019ffd19-7731-70ac-851f-1cbf05fa90e9.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.commonspirit.org/find-a-location/st-lukes-health-brazosport-hospital-lake-jackson-tx-758",
      "poi_directions_map_url": "https://maps.google.com/?cid=15834579207016192702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-health---brazosport-hospital---lake-jackson-tx",
      "poi_latitude": "29.0295926",
      "poi_longitude": "-95.4527813",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 979-297-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b4f8-76bb-9753-1122805dcd58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b4f8-76bb-9753-1122805dcd58",
        "storage_key": "property/6767906449167662/019ffd19-b4f8-76bb-9753-1122805dcd58.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwucRd9DQIYRvpr8weS5v9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7ad70347-da07-4e95-88b5-2c291e9fbe9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Altus Emergency Center - Lake Jackson Emergency Room",
      "poi_type": "Health and Wellness",
      "poi_address": "200 Oak Dr S, Lake Jackson, TX 77566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-fad0-73f9-9a3c-7d9fecb29def.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-fad0-73f9-9a3c-7d9fecb29def",
        "storage_key": "property/6767906449167662/019ffd1c-fad0-73f9-9a3c-7d9fecb29def.webp",
        "width": 712,
        "height": 506
      },
      "poi_business_url": "https://altusemergency.com/locations/lake-jackson/?utm_source=GBPlistingAECwebsiteLakeJackson&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=9444824603752981526&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "altus-emergency-center---lake-jackson-emergency-room",
      "poi_latitude": "29.0333117",
      "poi_longitude": "-95.452719",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 979-426-7644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_5ITd5DQIYRFuSQsO_BEoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_b48dd701-a9cf-43d6-a1fa-5d4de5bbfe0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Next Level Urgent Care - Lake Jackson",
      "poi_type": "Health and Wellness",
      "poi_address": "101 Winding Way St, Lake Jackson, TX 77566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-fb31-7049-93db-cea637126bab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-fb31-7049-93db-cea637126bab",
        "storage_key": "property/6767906449167662/019ffd1c-fb31-7049-93db-cea637126bab.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.nextlevelurgentcare.com/locations/lake-jackson/?utm_source=gbp&utm_medium=organic&utm_campaign=lake_jackson",
      "poi_directions_map_url": "https://maps.google.com/?cid=11448572634336162840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "next-level-urgent-care---lake-jackson",
      "poi_latitude": "29.0422832",
      "poi_longitude": "-95.4441333",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-783-8162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm_IxhVVDQIYRGHTdXieA4Z4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_3557c609-c203-4845-a8f1-5ecfe1c34121",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "51 Dixie Dr Walgreens, Clute, TX 77531, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-fe00-70fe-b293-6a920781b493.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-fe00-70fe-b293-6a920781b493",
        "storage_key": "property/6767906449167662/019ffd1c-fe00-70fe-b293-6a920781b493.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-51+dixie+dr-clute-tx-77531/id=4100",
      "poi_directions_map_url": "https://maps.google.com/?cid=14212724067816700479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "29.0184088",
      "poi_longitude": "-95.4196516",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-265-2517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3ce9-74ca-b6c2-fc57c266ad88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3ce9-74ca-b6c2-fc57c266ad88",
        "storage_key": "property/6767906449167662/019ffd1d-3ce9-74ca-b6c2-fc57c266ad88.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcw6AB5JBQIYRP_rbyDy9PcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_861788e6-39f1-4642-a779-27f0ecf3245e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "117 Oyster Creek Dr, Lake Jackson, TX 77566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1c-fc02-70ea-aadd-d0e734898011.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1c-fc02-70ea-aadd-d0e734898011",
        "storage_key": "property/6767906449167662/019ffd1c-fc02-70ea-aadd-d0e734898011.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/lake-jackson-tx-pharmacies/117-oyster-creek-dr-lake-jackson-tx-77566/storeid=6704?WT.mc_id=LS_GOOGLE_RX_6704",
      "poi_directions_map_url": "https://maps.google.com/?cid=13182979937541070876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.0444732",
      "poi_longitude": "-95.4488409",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 979-297-3254",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3ce9-74ca-b6c2-fc57c266ad88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3ce9-74ca-b6c2-fc57c266ad88",
        "storage_key": "property/6767906449167662/019ffd1d-3ce9-74ca-b6c2-fc57c266ad88.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcYqBtMVDQIYRHKA8Imha87Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c572839f-1be6-46a7-bad6-bf1c857a5756",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "208 TX-332, Lake Jackson, TX 77566, USA",
      "poi_short_description": "Membership-only chain gym providing tanning beds, massage chairs, and spa services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-4c4a-729d-a1ba-600244e6003f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd19-4c4a-729d-a1ba-600244e6003f",
        "storage_key": "property/6767906449167662/019ffd19-4c4a-729d-a1ba-600244e6003f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/lake-jackson-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11735470127292469651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.05",
      "poi_longitude": "-95.46652",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-968-7661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXRauttDQIYRk9F5UefD3KI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_75e4962e-8344-48d9-85e1-e8306ef279fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "CrossFit Fortify",
      "poi_type": "Health and Wellness",
      "poi_address": "236 Old Angleton Rd, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.crossfitfortify.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10108121448629014097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-fortify",
      "poi_latitude": "29.0265509",
      "poi_longitude": "-95.4011219",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 979-236-4135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx33jcLFDQIYRUQ4KBOdCR4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d082169c-d757-4dbc-a27a-290f985a1fa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Yoga & Healing Co",
      "poi_type": "Health and Wellness",
      "poi_address": "810 Dixie Dr Ste J, Box 152, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-0576-756b-919e-20c252ef5475.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-0576-756b-919e-20c252ef5475",
        "storage_key": "property/6767906449167662/019ffd1d-0576-756b-919e-20c252ef5475.webp",
        "width": 1170,
        "height": 639
      },
      "poi_business_url": "http://www.sriyogaschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4679653629711396803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoga--healing-co",
      "poi_latitude": "29.0124936",
      "poi_longitude": "-95.4206657",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-204-7951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDW08nZRDQIYRw6_Qri548UA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_996208c5-8d62-42b5-a77a-5a7873852048",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Frank W Stevens Center For Health",
      "poi_type": "Health and Wellness",
      "poi_address": "140 E Hospital Dr, Angleton, TX 77515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.utmb.edu/utmbhealth/locations/hospitals-campuses/angleton-danbury-campus/hospital/wellness",
      "poi_directions_map_url": "https://maps.google.com/?cid=9406695738828028614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frank-w-stevens-center-for-health",
      "poi_latitude": "29.1848169",
      "poi_longitude": "-95.4035223",
      "poi_miles_from_property": "12.3",
      "poi_walking_minutes": "4 hours 29 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 979-848-9109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3UbEDpFdQIYRxnoGh-9Li4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_1eaf032a-2664-4d38-adbc-78686c15fedf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Clute Municipal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Parkview Dr, Clute, TX 77531, USA",
      "poi_short_description": "Popular green space featuring a ballfield, a playground and a disc-golf course.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-0d38-7189-81ea-69a5307c710a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-0d38-7189-81ea-69a5307c710a",
        "storage_key": "property/6767906449167662/019ffd1d-0d38-7189-81ea-69a5307c710a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/Clute-Parks-Recreation-Dept-100057368324759/",
      "poi_directions_map_url": "https://maps.google.com/?cid=332284727502751729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clute-municipal-park",
      "poi_latitude": "29.0248902",
      "poi_longitude": "-95.4071273",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 979-265-8392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d1-750e-a56e-5789d23133ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d1-750e-a56e-5789d23133ab",
        "storage_key": "property/6767906449167662/019ffd19-b1d1-750e-a56e-5789d23133ab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM04K1fZBQIYR8ccW-zKDnAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9a99eff4-aef4-4d86-8f31-466389e52461",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Stratton Ridge Sportsplex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "947 Stratton Ridge Rd, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-08d6-7711-b214-8b7d694008db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-08d6-7711-b214-8b7d694008db",
        "storage_key": "property/6767906449167662/019ffd1d-08d6-7711-b214-8b7d694008db.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14868554503396748117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stratton-ridge-sportsplex",
      "poi_latitude": "29.0286066",
      "poi_longitude": "-95.382068",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 979-265-7315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d1-750e-a56e-5789d23133ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d1-750e-a56e-5789d23133ab",
        "storage_key": "property/6767906449167662/019ffd19-b1d1-750e-a56e-5789d23133ab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs4CFQgNqQIYRVWt_Oou3V84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6ad16c39-c053-4817-baeb-b805b2d86450",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Broaddus Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1298-1100 4th St, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-124a-75c0-a07b-bc8b955f9261.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-124a-75c0-a07b-bc8b955f9261",
        "storage_key": "property/6767906449167662/019ffd1d-124a-75c0-a07b-bc8b955f9261.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13267606839674361851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broaddus-park",
      "poi_latitude": "29.0341902",
      "poi_longitude": "-95.3924508",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d1-750e-a56e-5789d23133ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d1-750e-a56e-5789d23133ab",
        "storage_key": "property/6767906449167662/019ffd19-b1d1-750e-a56e-5789d23133ab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKyyoS_5pQIYR-1dVOiACILg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f168de74-a529-42bc-b3bd-192328d07aa8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Hardy Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12152255136336791831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hardy-park",
      "poi_latitude": "29.0169826",
      "poi_longitude": "-95.4106092",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d1-750e-a56e-5789d23133ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d1-750e-a56e-5789d23133ab",
        "storage_key": "property/6767906449167662/019ffd19-b1d1-750e-a56e-5789d23133ab.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4SbRO1BQIYRF0lFPal7pag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2ad8b9fd-2a3d-4f14-89a9-b324acd9dd57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Dunbar Park Pavilion",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "803 FM 2004, Lake Jackson, TX 77566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-11d8-772a-b792-0d3116202139.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-11d8-772a-b792-0d3116202139",
        "storage_key": "property/6767906449167662/019ffd1d-11d8-772a-b792-0d3116202139.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "https://www.lakejackson-tx.gov/Facilities/Facility/Details/Dunbar-Park-7",
      "poi_directions_map_url": "https://maps.google.com/?cid=4222025773114207252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunbar-park-pavilion",
      "poi_latitude": "29.0598896",
      "poi_longitude": "-95.4518439",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 979-297-4533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo5nfaB5DQIYRFCwERxKmlzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e2380715-3ef0-44c4-93e5-b4dc8de996c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Gulf Coast Transit District (GCTD)",
      "poi_type": "Transportation & Transit",
      "poi_address": "1415 33rd St N, Texas City, TX 77590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-13e0-770d-a55f-29b3f6342030.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-13e0-770d-a55f-29b3f6342030",
        "storage_key": "property/6767906449167662/019ffd1d-13e0-770d-a55f-29b3f6342030.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gulfcoasttransitdistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1557073016322190706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-coast-transit-district-gctd",
      "poi_latitude": "29.3973505",
      "poi_longitude": "-94.9444444",
      "poi_miles_from_property": "48.7",
      "poi_walking_minutes": "17 hours 40 mins",
      "poi_biking_minutes": "3 hours 33 mins",
      "poi_driving_minutes": "54 mins",
      "poi_business_phone": "+1 800-266-2320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7X9zOkd5P4YRcu06m6jVmxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_128ff52a-871b-4db6-9a27-eb76fb02833f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Texas Gulf Coast Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8000 Airport Wy Ste 118, Angleton, TX 77515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-1889-71a8-8d75-6aeeaa22f124.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-1889-71a8-8d75-6aeeaa22f124",
        "storage_key": "property/6767906449167662/019ffd1d-1889-71a8-8d75-6aeeaa22f124.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.flylbx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6639755852746932833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-gulf-coast-regional-airport",
      "poi_latitude": "29.1109307",
      "poi_longitude": "-95.4591026",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 979-849-5755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3cdd-75c9-8f06-ffbac49cc42c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3cdd-75c9-8f06-ffbac49cc42c",
        "storage_key": "property/6767906449167662/019ffd1d-3cdd-75c9-8f06-ffbac49cc42c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJy68viudDQIYRYUJN5sQmJVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_76c0da45-c162-4ae8-9348-8e829b92b9a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Buc-ee's, Limited",
      "poi_type": "Shopping & Retail",
      "poi_address": "327 FM 2004, Lake Jackson, TX 77566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-142e-7770-a52d-6c1e21d802c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-142e-7770-a52d-6c1e21d802c2",
        "storage_key": "property/6767906449167662/019ffd1d-142e-7770-a52d-6c1e21d802c2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.buc-ees.com/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=14168861637073279724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buc-ees-limited",
      "poi_latitude": "29.0633268",
      "poi_longitude": "-95.4366121",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3c81-7138-9381-443596d241b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3c81-7138-9381-443596d241b4",
        "storage_key": "property/6767906449167662/019ffd1d-3c81-7138-9381-443596d241b4.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJafROH0VDQIYR7JppzZboocQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_56741f53-320b-4996-97ba-0e5c4255a8af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "William P. Hobby Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7800 Airport Blvd, Houston, TX 77061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-1e59-71e8-9547-b9d57bb9ff43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-1e59-71e8-9547-b9d57bb9ff43",
        "storage_key": "property/6767906449167662/019ffd1d-1e59-71e8-9547-b9d57bb9ff43.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fly2houston.com/hou/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10811035190079821913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-p-hobby-airport",
      "poi_latitude": "29.6459141",
      "poi_longitude": "-95.2768951",
      "poi_miles_from_property": "49.2",
      "poi_walking_minutes": "17 hours 59 mins",
      "poi_biking_minutes": "4 hours 53 mins",
      "poi_driving_minutes": "1 hour 0 mins",
      "poi_business_phone": "+1 713-640-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3cdd-75c9-8f06-ffbac49cc42c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3cdd-75c9-8f06-ffbac49cc42c",
        "storage_key": "property/6767906449167662/019ffd1d-3cdd-75c9-8f06-ffbac49cc42c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2ZP70-WQIYRWZj03jmDCJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_c8309872-bc00-4a9b-b47b-932371704368",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Brazosport Independent School District",
      "poi_type": "Education",
      "poi_address": "301 Brazoswood Dr, Clute, TX 77531, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-23e7-7425-b164-3d4f1ba745b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-23e7-7425-b164-3d4f1ba745b0",
        "storage_key": "property/6767906449167662/019ffd1d-23e7-7425-b164-3d4f1ba745b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brazosportisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1952567166338871579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brazosport-independent-school-district",
      "poi_latitude": "29.0243677",
      "poi_longitude": "-95.4154167",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 979-265-6181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b28b-70de-9e39-b61eda1723ea",
        "storage_key": "property/6767906449167662/019ffd19-b28b-70de-9e39-b61eda1723ea.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa-GIF4tBQIYRGzG4HX7pGBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bb9e2135-427c-4d23-ba61-3de8199f2a92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Dow Texas Operations",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Dow, 2301 N Brazosport Blvd, Freeport, TX 77541, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-26ec-722e-a7ed-6f5e55eccb56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-26ec-722e-a7ed-6f5e55eccb56",
        "storage_key": "property/6767906449167662/019ffd1d-26ec-722e-a7ed-6f5e55eccb56.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.dow.com/locations/texas/freeport/contact/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17060156095206889316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dow-texas-operations",
      "poi_latitude": "28.9853729",
      "poi_longitude": "-95.3769627",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKXj4amJqQIYRZJeFe5TZwew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7514fc64-e508-4288-bbde-0f9fbae008a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "BASF Chemicals Division",
      "poi_type": "Major Employers & Offices",
      "poi_address": "602 Copper Rd, Freeport, TX 77541, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-2638-761f-98c1-6e68d693b14a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-2638-761f-98c1-6e68d693b14a",
        "storage_key": "property/6767906449167662/019ffd1d-2638-761f-98c1-6e68d693b14a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.basf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8567026760997011700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "basf-chemicals-division",
      "poi_latitude": "29.0032974",
      "poi_longitude": "-95.3946559",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 979-415-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP9zVmnVqQIYR9AB-9nIx5HY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d951c8ac-f4bb-42ed-86bf-1b0304e01c5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Freeport LNG Badge Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1602 Lamar St, Quintana, TX 77541, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7799934444211558675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freeport-lng-badge-office",
      "poi_latitude": "28.9279411",
      "poi_longitude": "-95.3192349",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 40 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZjmZwAVQIYRE1mQGg3vPmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_7d91d62c-f7b3-4def-b9ee-4ca5a25c0ded",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Port Freeport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1100 Cherry St, Freeport, TX 77541, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-28e4-7213-93a3-764abec62afa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-28e4-7213-93a3-764abec62afa",
        "storage_key": "property/6767906449167662/019ffd1d-28e4-7213-93a3-764abec62afa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.portfreeport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16305516927431804684&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-freeport",
      "poi_latitude": "28.9406025",
      "poi_longitude": "-95.3515438",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 979-233-2667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3c87-72a9-af15-30bf7fa52600.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3c87-72a9-af15-30bf7fa52600",
        "storage_key": "property/6767906449167662/019ffd1d-3c87-72a9-af15-30bf7fa52600.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_Xm6tQUQIYRDAexUkHVSOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_82b031f8-b4ff-48a3-b0e4-42fc69d14c12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Chevron Phillips Chemical",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21441 Freedom Ln, Sweeny, TX 77480, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-2d40-758d-b70b-fa1c3dfa33a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-2d40-758d-b70b-fa1c3dfa33a2",
        "storage_key": "property/6767906449167662/019ffd1d-2d40-758d-b70b-fa1c3dfa33a2.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.cpchem.com/locations/north-america/brazoria-county-texas",
      "poi_directions_map_url": "https://maps.google.com/?cid=352981685969762655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevron-phillips-chemical",
      "poi_latitude": "29.0816075",
      "poi_longitude": "-95.74175",
      "poi_miles_from_property": "27.3",
      "poi_walking_minutes": "9 hours 58 mins",
      "poi_biking_minutes": "2 hours 5 mins",
      "poi_driving_minutes": "41 mins",
      "poi_business_phone": "+1 979-491-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTnD7vGyQYYRXzlyJPkK5gQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_483b2936-cb94-43be-9e65-333ad6ba4fb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Olin Corporation OC-1120",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4302 TX-332, Freeport, TX 77541, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3182-75ac-bdd3-ee833e2ef3e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3182-75ac-bdd3-ee833e2ef3e3",
        "storage_key": "property/6767906449167662/019ffd1d-3182-75ac-bdd3-ee833e2ef3e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.olin.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12777005689935117368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olin-corporation-oc-1120",
      "poi_latitude": "28.9816886",
      "poi_longitude": "-95.3384947",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 314-480-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd19-b1d5-707c-b899-85af358a1216",
        "storage_key": "property/6767906449167662/019ffd19-b1d5-707c-b899-85af358a1216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBcifLwlrQIYRODy6wfoKUbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_a190629b-1ff5-4026-8997-8ca218762e76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "poi_name": "Brazoria County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 E Locust St, Angleton, TX 77515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-2c0e-74ee-96ff-ebffd3ba8f29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-2c0e-74ee-96ff-ebffd3ba8f29",
        "storage_key": "property/6767906449167662/019ffd1d-2c0e-74ee-96ff-ebffd3ba8f29.webp",
        "width": 789,
        "height": 576
      },
      "poi_business_url": "https://www.brazoriacountytx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1609516212735041727&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brazoria-county-courthouse",
      "poi_latitude": "29.1682066",
      "poi_longitude": "-95.4313827",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 979-849-5711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd1d-3c87-72a9-af15-30bf7fa52600.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-3c87-72a9-af15-30bf7fa52600",
        "storage_key": "property/6767906449167662/019ffd1d-3c87-72a9-af15-30bf7fa52600.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJezxKpQBdQIYRv-BNyHcmVhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_b45a8cdbc74db7b91bf12c9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_074a54cc42d35ad7f901e162",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9f3af879cde1b8b17ae72d50",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_39b49cbffd9e100f8de8215f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b9af214902047dcd141fc517",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_8e61570e07e13736553ce77b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_465bcdefa835fed8c3c29a11",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "rating": "5",
      "name": "Mike Harris",
      "text": "Stephanie was great helpful enjoy company and time and patience. She’s very awesome. She helped me through. You guys are blessed to have her on your team so God will keep it going strong. Love you guys amazing. God bless and bless her continuously.",
      "date": "2026-05-21",
      "title": "false"
    },
    {
      "id": "ec_ecb8aec5a0cd87a58bcdadcd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "rating": "5",
      "name": "Tera Stowe",
      "text": "Hackberry Ranch has been a safe and beautiful environment for my Grandson and his wife and daughter to grow in this last year. I recommend Hackberry Ranch to anyone that ask about apartments. Being a Grandmother and Great Grandmother I don't worry about them because they live there. Awesome Staff  Thanks Tera Hollie Stowe",
      "date": "2026-05-07",
      "title": "false"
    },
    {
      "id": "ec_e9f3cc0244175ceeb178745a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "rating": "5",
      "name": "It's your boy Jamie",
      "text": "Great place to live in been here 4 or 5 years by now they do little party's for the people that live there today they did crawfish and it was good the workers are friendly and good people and they are on it when you need something done in the apartments 10 out of 10 will continue to live here",
      "date": "2026-03-21",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_1d82f19d-edbf-45d4-a4e3-92c61c60c0e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167662/019ffd19-8034-7647-bb49-01f451198690.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ffd19-8034-7647-bb49-01f451198690",
        "storage_key": "property/6767906449167662/019ffd19-8034-7647-bb49-01f451198690.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Hackberry Ranch Apartments",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6a430315c65c4d109ab3d647&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a04a29-4a0f-7139-9483-dc5eda1d960c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Hackberry Ranch Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662"
    },
    {
      "lead_collector_id": "01a04a29-4a9b-7646-8818-70fc6cc0bfaa",
      "lead_source": "LANDING_PAGE",
      "name": "Hackberry Ranch Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-clute-tx",
      "search_query": "dog friendly apartments Clute TX",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Clute, TX",
      "h2_subtitle": "Looking for dog-friendly apartments in Clute? Hackberry Ranch offers pet-friendly living with a dedicated dog park and spacious floor plans.",
      "page_copy": "Discover pet-friendly apartments in Clute, TX, at Hackberry Ranch. Our community offers pet-friendly features, including an on-site dog park where four-legged residents can enjoy time outdoors.\n\nLocated in Brazoria County, Hackberry Ranch combines convenient apartment features with a variety of community amenities. Enjoy efficient appliances, on-site management and maintenance services, a playground, landscaped grounds, and dedicated outdoor space for pets. Explore pet-friendly apartment living in Clute, TX, and discover what Hackberry Ranch has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Clute, TX",
      "seo_description": "Explore Hackberry Ranch, offering dog-friendly apartments in Clute, TX with a dedicated dog park and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "apartments-with-pools-77531",
      "search_query": "apartments with pools 77531",
      "category": "Amenity",
      "h1_title": "Find Apartments with Pools in 77531",
      "h2_subtitle": "Discover apartments with pools in the 77531 area at Hackberry Ranch. Enjoy comfortable living with amenities that cater to your lifestyle.",
      "page_copy": "Discover apartments with a pool in 77531 at Hackberry Ranch. Located in the 77531 area, our community offers a refreshing swimming pool where residents can enjoy time outdoors along with a variety of other convenient amenities.\n\nBeyond the pool, Hackberry Ranch offers community features including a playground, an on-site dog park, and on-site management and maintenance services. Inside our apartment homes, efficient appliances add convenience to your everyday routine. Explore Hackberry Ranch and discover apartment living with a pool and convenient amenities in Clute, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments with Pools in 77531",
      "seo_description": "Discover Hackberry Ranch, your choice in 77531. Enjoy community features and amenities that ensure comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "apartments-with-dishwasher-brazoria-county",
      "search_query": "apartments with dishwasher Brazoria County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Brazoria County",
      "h2_subtitle": "Looking for apartments with a dishwasher in Brazoria County? Hackberry Ranch provides efficient living solutions including modern appliances.",
      "page_copy": "## Apartments with Dishwashers in Brazoria County\n\nDiscover apartments with dishwashers at Hackberry Ranch in Clute, TX. Located in Brazoria County, our apartment homes feature efficient appliances, including a dishwasher, to add convenience to your everyday routine.\n\nHackberry Ranch offers spacious floor plans along with a variety of community amenities. Residents can enjoy a swimming pool, playground, on-site dog park, and on-site management and maintenance services. Explore Hackberry Ranch and discover comfortable apartment living with convenient in-home features and community amenities in Brazoria County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher, Brazoria County",
      "seo_description": "Find your ideal home at Hackberry Ranch, featuring apartments with dishwashers and more in Brazoria County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-clute",
      "search_query": "fitness center apartments in Clute",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Clute, TX",
      "h2_subtitle": "Discover fitness-centered living at Hackberry Ranch in Clute. While we don't have a fitness center, our community offers ample outdoor spaces and more.",
      "page_copy": "Discover convenient apartment living at Hackberry Ranch in Clute, TX. Our community offers a variety of outdoor amenities, including a swimming pool, playground, landscaped grounds, and a dedicated dog park.\n\nLocated in Brazoria County, Hackberry Ranch also offers convenient features such as on-site management and maintenance services, along with efficient appliances in each apartment home. Whether you're exploring our outdoor spaces or relaxing at the community pool, Hackberry Ranch provides a variety of amenities to complement your everyday routine.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Clute, TX",
      "seo_description": "Explore Hackberry Ranch for active living in Clute, TX. Enjoy outdoor spaces and amenities close to home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "playground-apartments-brazoria-county",
      "search_query": "playground apartments in Brazoria County",
      "category": "Amenity",
      "h1_title": "Playground Apartments in Brazoria County",
      "h2_subtitle": "Hackberry Ranch offers convenient apartment living in Brazoria County with an on-site playground and a variety of community amenities.",
      "page_copy": "Discover apartments with a playground at Hackberry Ranch in Clute, TX. Located in Brazoria County, our community offers a variety of outdoor amenities, including an on-site playground, swimming pool, landscaped grounds, and dedicated dog park.\n\nHackberry Ranch also offers convenient apartment and community features, including efficient appliances and on-site management and maintenance services. With thoughtfully maintained outdoor spaces and a variety of amenities available throughout the community, Hackberry Ranch offers comfortable and convenient apartment living in Clute, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Playground Apartments in Brazoria County",
      "seo_description": "Discover comfortable apartment living at Hackberry Ranch, featuring an on-site playground and convenient community amenities in Brazoria County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-clute-tx",
      "search_query": "one bedroom apartments clute tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Clute, TX",
      "h2_subtitle": "Discover comfortable one bedroom apartments at Hackberry Ranch, conveniently located in Clute, TX, offering modern amenities and a vibrant community.",
      "page_copy": "Discover one-bedroom apartments in Clute, TX, at Hackberry Ranch. Our thoughtfully designed floor plans offer comfortable living spaces with efficient appliances and convenient in-home features for your everyday routine.\n\nLocated in Brazoria County, Hackberry Ranch offers more than spacious one-bedroom floor plans. Community amenities include a swimming pool, playground, dog park, and on-site management and maintenance services. Explore our one-bedroom apartments and discover the features and amenities available at Hackberry Ranch in Clute, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Clute, TX",
      "seo_description": "Find cozy one bedroom apartments at Hackberry Ranch in Clute, TX with modern amenities and great community features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "two-bedroom-floorplans-brazoria-county",
      "search_query": "two bedroom floorplans brazoria county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floorplans in Brazoria County",
      "h2_subtitle": "Explore spacious two-bedroom floor plans at Hackberry Ranch, located in scenic Brazoria County with top-notch amenities and a welcoming community.",
      "page_copy": "Discover spacious two-bedroom apartments at Hackberry Ranch in Clute, TX. Our thoughtfully designed two-bedroom floor plans feature efficient appliances and functional layouts that provide flexibility and comfortable living space.\n\nLocated in Brazoria County, Hackberry Ranch complements its apartment homes with a variety of community amenities, including a swimming pool, playground, dog park, and on-site management and maintenance services. Explore our available two-bedroom apartments and discover the floor plans, features, and amenities Hackberry Ranch has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floorplans in Brazoria County",
      "seo_description": "Discover spacious two bedroom floorplans at Hackberry Ranch in Brazoria County, offering a vibrant community and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "three-bedroom-rentals-near-77531",
      "search_query": "three bedroom rentals near 77531",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Rentals Near 77531",
      "h2_subtitle": "Find spacious three-bedroom apartments at Hackberry Ranch in Clute, TX 77531, featuring thoughtfully designed floor plans and convenient community amenities.",
      "page_copy": "## Three-Bedroom Apartments in Clute, TX 77531\n\nDiscover spacious three-bedroom apartments at Hackberry Ranch in Clute, TX 77531. Our thoughtfully designed three-bedroom floor plans offer generous living space, functional layouts, efficient appliances, and convenient in-home features.\n\nHackberry Ranch also offers a variety of community amenities, including a swimming pool, playground, dog park, and on-site management and maintenance services. Explore our available three-bedroom apartments and discover the floor plans, features, and community amenities available at Hackberry Ranch in Clute, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Rentals Near 77531",
      "seo_description": "Discover three-bedroom apartments at Hackberry Ranch in Clute, TX 77531, featuring thoughtfully designed floor plans and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "apartments-near-brazosport-college-clute-tx",
      "search_query": "apartments near brazosport college clute tx",
      "category": "School",
      "h1_title": "Apartments Near Brazosport College, Clute, TX",
      "h2_subtitle": "Discover convenient living at Hackberry Ranch, offering modern apartments just minutes from Brazosport College in Clute, TX.",
      "page_copy": "Discover apartments near Brazosport College at Hackberry Ranch in Clute, TX. Our convenient location provides easy access to the college as well as nearby shopping, dining, and other destinations throughout the Clute area.\n\nHackberry Ranch offers thoughtfully designed apartment homes with efficient appliances and a variety of community amenities, including a swimming pool, playground, and dog park. Residents also benefit from on-site management and maintenance services. Explore Hackberry Ranch and discover convenient apartment living near Brazosport College in Clute, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Brazosport College, Clute, TX",
      "seo_description": "Find apartments near Brazosport College at Hackberry Ranch, with modern amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "apartments-near-st-lukes-health-brazosport-hospital",
      "search_query": "apartments near St. Luke's Health - Brazosport Hospital Lake Jackson",
      "category": "Hospital",
      "h1_title": "Apartments Near St. Luke's Health Brazosport",
      "h2_subtitle": "Explore convenient apartment living near St. Luke's Health Brazosport Hospital. Hackberry Ranch offers a welcoming community close to Lake Jackson.",
      "page_copy": "Discover apartments near St. Luke's Health–Brazosport Hospital at Hackberry Ranch in Clute, TX. Located a short drive from the hospital in Lake Jackson, our community offers convenient access to this major local healthcare destination as well as nearby shopping, dining, and services.\n\nHackberry Ranch features comfortable apartment homes with efficient appliances and a variety of community amenities, including a swimming pool, playground, and dog park. On-site management and maintenance services provide additional convenience. Explore Hackberry Ranch and discover apartment living with convenient access to St. Luke's Health–Brazosport Hospital and destinations throughout the Clute and Lake Jackson area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Luke's Health Brazosport",
      "seo_description": "Find apartments near St. Luke's Health Brazosport Hospital. Short drive from Lake Jackson with great amenities at Hackberry Ranch.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "apartments-near-aa-maclean-park-clute",
      "search_query": "apartments near a.a. maclean park clute",
      "category": "Park",
      "h1_title": "Apartments Near A.A. MacLean Park, Clute",
      "h2_subtitle": "Discover apartments near A.A. MacLean Park in Clute, TX. Hackberry Ranch offers convenient access to local recreation and a variety of community amenities.",
      "page_copy": "Enjoy convenient access to A.A. MacLean Park when you make your home at Hackberry Ranch in Clute, TX. Located near this popular local park, our community puts outdoor recreation and green space within easy reach.\n\nHackberry Ranch offers a variety of apartment and community amenities designed for everyday convenience, including efficient appliances, an interactive playground, and a well-maintained dog park. On-site management and maintenance services add to the convenience of living at Hackberry Ranch. Explore comfortable apartment living in Clute with convenient access to A.A. MacLean Park and other nearby destinations.\n",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near A.A. MacLean Park, Clute",
      "seo_description": "Live near A.A. MacLean Park at Hackberry Ranch in Clute, TX. Enjoy convenient access to the park, along with modern apartment and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "living-close-to-oyster-creek-municipal-park",
      "search_query": "living close to oyster creek municipal park brazoria county",
      "category": "Park",
      "h1_title": "Living Close to Oyster Creek Municipal Park",
      "h2_subtitle": "Experience serene living near Oyster Creek Municipal Park in Brazoria County. Hackberry Ranch offers a perfect blend of comfort and convenience.",
      "page_copy": "Discover the convenience of living near Oyster Creek Municipal Park at Hackberry Ranch in Brazoria County. Our community offers easy access to the park, providing opportunities to enjoy outdoor recreation and green space close to home.\n\nAt Hackberry Ranch, residents can enjoy a variety of apartment and community amenities, including efficient appliances, a playground, and a dog park. With convenient access to Oyster Creek Municipal Park and thoughtfully designed amenities, Hackberry Ranch offers comfortable apartment living in Clute, TX.\n",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Oyster Creek Municipal Park",
      "seo_description": "Discover Hackberry Ranch's apartments, close to Oyster Creek Municipal Park in Brazoria County, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167662",
      "source": "custom",
      "page_item_url": "apartment-homes-by-jasmine-park-77531",
      "search_query": "apartment homes by jasmine park 77531",
      "category": "Park",
      "h1_title": "Apartment Homes by Jasmine Park, 77531",
      "h2_subtitle": "Find gorgeous apartment homes conveniently located near Jasmine Park in the heart of 77531. Hackberry Ranch offers unparalleled comfort and style.",
      "page_copy": "Discover apartment living near Jasmine Park at Hackberry Ranch in Clute, TX 77531. With convenient access to the park, residents can enjoy nearby green spaces and recreational opportunities while staying close to home.\n\nHackberry Ranch offers a variety of apartment and community amenities, including energy-efficient appliances, a playground, and a dedicated dog park. On-site management and maintenance services provide added convenience for residents. Experience comfortable apartment living near Jasmine Park and explore everything Hackberry Ranch has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes by Jasmine Park, 77531",
      "seo_description": "Explore Hackberry Ranch's stylish apartment homes near Jasmine Park, 77531, offering modern amenities and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "brianna@repli360.com"
    },
    {
      "ID": "custom_gbp_utm",
      "type": "STRING",
      "value": "https://www.renthackberryranch.com?rcstdid=MQ%3d%3d-WOzw8Oa5P2c%3d"
    },
    {
      "ID": "custom_sem_utm",
      "type": "STRING",
      "value": "https://www.renthackberryranch.com?rcstdid=MQ%3d%3d-WOzw8Oa5P2c%3d"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12795351047"
    },
    {
      "ID": "custom_website_utm",
      "type": "STRING",
      "value": "https://www.renthackberryranch.com?rcstdid=Mg%3d%3d-YRjTEizZPgM%3d&?utm_source=organic&utm_medium=propertywebsite&utm_campaign=repli360"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TZMGL767"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Avenue"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/app/?property=c0276eb4-ab64-40ab-a316-d5f628201331&propertyName=Hackberry+Ranch&companyName=Mox&widget=webchat&gaTracking=G-9YRWWQG56E&buttonbgcolor=000000&buttontextcolor=ffffff&chatheader=0&embed=false&textuschannel=ca1c1ea1-b918-4280-8c4e-00e507d49a60&ctu=4417146778&ctv=7134306161\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57322526223"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bcd1707-74a8-4db5-b1de-bca46b2e676e"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "888-296-7438"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imk5TWJkWDhtQU1mdUcvMkQwWTFXZlE9PSIsInZhbHVlIjoiWmU0RG5RTE1LS01EcVU4UkZlT1hBUT09IiwibWFjIjoiNzNhZjE4NTYyZTZmYWM3MWE3Nzc2ODZlYWU4NmVhOTUxNTc2NDZiZjRlMzcwZDUyNWQ1MTk2ZDE5NTgwNmEwYyJ9"
    }
  ],
  "custom_csm": "brianna@repli360.com",
  "custom_gbp_utm": "https://www.renthackberryranch.com?rcstdid=MQ%3d%3d-WOzw8Oa5P2c%3d",
  "custom_sem_utm": "https://www.renthackberryranch.com?rcstdid=MQ%3d%3d-WOzw8Oa5P2c%3d",
  "custom_repli_id": "12795351047",
  "custom_website_utm": "https://www.renthackberryranch.com?rcstdid=Mg%3d%3d-YRjTEizZPgM%3d&?utm_source=organic&utm_medium=propertywebsite&utm_campaign=repli360",
  "custom_google_gtm_id": "GTM-TZMGL767",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Avenue",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/app/?property=c0276eb4-ab64-40ab-a316-d5f628201331&propertyName=Hackberry+Ranch&companyName=Mox&widget=webchat&gaTracking=G-9YRWWQG56E&buttonbgcolor=000000&buttontextcolor=ffffff&chatheader=0&embed=false&textuschannel=ca1c1ea1-b918-4280-8c4e-00e507d49a60&ctu=4417146778&ctv=7134306161\"></script>",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57322526223",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_organization_id": "4bcd1707-74a8-4db5-b1de-bca46b2e676e",
  "custom_ppc_tracking_phone_number": "888-296-7438",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imk5TWJkWDhtQU1mdUcvMkQwWTFXZlE9PSIsInZhbHVlIjoiWmU0RG5RTE1LS01EcVU4UkZlT1hBUT09IiwibWFjIjoiNzNhZjE4NTYyZTZmYWM3MWE3Nzc2ODZlYWU4NmVhOTUxNTc2NDZiZjRlMzcwZDUyNWQ1MTk2ZDE5NTgwNmEwYyJ9"
};

export const generatedAt = '2026-10-06T21:26:26.322Z';
